import React from 'react'
import { createContext, useState, useRef } from "react";
import AuthContext from "./AuthContext.js";
import StatusContext from "./StatusContext.js";
import ClientContext from "./ClientContext.js";
import axios from "axios"

import { config } from '../config.js';

const AITestContext = createContext();

export default AITestContext;

export const AITestProvider = ((props) => {

    const {
        isMe,
        isLoading,
        setIsLoading,
        setStatusNavbar,
        changeLanguage,
        getAIProvider, 
        getAIName,
        getAIModel,
        setWaitOnResponse,
        handleFocus,
        setShowBuyTestDialog,
        setTestLanguage,
        changeTestLanguage,
        testlanguage,
        isPromotion,
      
    } = React.useContext(StatusContext);


    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [subtopics, setSubtopics] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [chatcollegetestName, setChatCollegeTestName] = useState('')
    const [chatcollegetestNames, setChatCollegeTestNames] = useState([])
    const [boughtchatNames, setBoughtChatNames] = useState([])
    const [mycreatedchatNames, setMyCreatedChatNames] = useState([])
    const [topic, setTopic] = useState('')
    const [status, setStatus] = useState();
    const [reset, setReset] = useState(false)
    const[createtestmode, setCreateTestMode] = useState(false)
    const[selecttestmode, setSelectTestMode] = useState(false)
    const[showaccount, setShowAccount] = useState(false)
    const [expanded, setExpanded] = useState(false);
    const [testprice, setTestPrice] = useState('0.00');
    const [creatorname, setCreatorName] = useState('');
    const [description, setDescription] = useState('')
    const [openDialog, setOpenDialogBox] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialogBox] = useState(false);
    const [dialogboxtext, setDialogBoxText] = useState('')
    const [accountbalance, setAccountBalance] = useState('0.00');
    const [testpreview, setTestPreview] = useState(false)
    const[testactive, setTestActive] = useState(false)
    const [testactivity, setTestActivity] = useState([]);
    const[connectedAccount, setConnectedAccount] = useState({
        account:'',
        verified: false
    });
    const [displayedChosenChat, setDisplayedChosenChat] = useState()
    const[ openSaveChosenTestDialog, handleSaveChosenTestDialog] = useState(false)
    const [verifyaccount, setVerifyAccount] = useState(false);
    const [buyprice, setBuyPrice] = useState(0)
    const [buytestname, setBuyTestName] = useState('')
    const [buytestcreatorid, setBuyTestCreatorId] = useState('')
    const [buytestchatauthorkey, setBuyTestChatAuthorKey] = useState('')
    const [moreanswer, setMoreAnswer] = useState('')
    const [showmoreanswerdialog, setShowMoreAnswerDialog] = useState(false)
    const [answer, setAnswer] = useState('')
    const [moreanswerstatus, setMoreAnswerStatus] = useState(false)
    const [showModifyTestDialog, setShowModifyTestDialog] = useState(false)
    const [modifyTest, setModifyTest] = useState(null)
    const [questionsMoreAnswer, setQuestionsMoreAnswer] = useState(
        {
            id:0,
            question1: '',
            question2: '',
            question3: '',
        }
    )
    const [testScore, setTestScore] = useState(0)
    const[showContext, setShowContext] = useState(false)
    const [showSubtopics, setShowSubtopics] = useState(false) 
    const [previewMessage, setPreviewMessage] = useState('')
    const [language, setLanguage] = useState('English');
    const [showTestLanguages,  setShowTestLanguages] = useState(false)
    const [showTestBought,  setShowTestBought] = useState(false)
    const [showMoreAnswerProgressDialog, setShowMoreAnswerProgressDialog] = useState(false)
    const [area, setArea] = useState('')
    const [subarea, setSubArea] = useState('')
    const [showTestAreaDlg,  setShowTestAreaDlg] = useState(false)
    const [showTestSubareaDlg,  setShowTestSubareaDlg] = useState(false)
    const [areaIndex, setAreaIndex] = useState(-1)
    const descriptionRef = useRef(null)
    const[collegetestmode, setCollegeTestMode] = useState(false)
    const[createcollegetestmode, setCreateCollegeTestMode] = useState(false)
    const [showalltests, setShowAllTests] = useState(true)
    const [showfavouritetests, setShowFavouriteTests] = useState(false)
    const [school, setSchool] = useState('Not selected');
    const [showTestSchool,  setShowTestSchool] = useState(false)
    const [schoolyear, setSchoolYear] = useState('First year');
    const [showcorrectanswersonly, setShowCorrectAnswersOnly] = useState(false)
    const [showschoolyearcourses, setShowSchoolYearCourses] = useState('First year')
   
    const [selectedcourse, setSelectedCourse] = useState('TESTOVI')
    const [universityindex, setUniversityIndex] = useState(0)
    const [collegeindex, setCollegeIndex] = useState(0)
    const [showTestSchoolYear,  setShowTestSchoolYear] = useState(false)
    const [showquestionsonly, setShowQuestionsOnly] = useState(false)
    const [boughtschoolyeartests, setBoughtSchoolYearTests] = useState([])
    const [boughtindividualschooltests, setBoughtIndividualSchoolTests] = useState([])
    const [testisbought, setTestIsBought] = useState(true)
    const [boughtcourse, setBoughtCourse] = useState('')
    const [showquestions, setShowQuestions] = useState(true)
    const [collegeindividualtestprice, setCollegeIndividualTestPrice] = useState(5.99)
    const [schoolyeartestsprice, setSchoolYearTestsPrice] = useState(24.99)
    const [individualtestspayment, setIndividualTestsPayment] = useState(0)
    const [schoolyeartestspayment, setShoolYearTestsPayment] = useState(0)
    const [collegeStats, setCollegeStats] = useState([]);


    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

    const  countClicks = async (buttonname) => {
         console.log("countClick:", currentUser, buttonname)

        if (isMe())
            return


        if (buttonname !== "Course" && buttonname !== "Test")
            return

        let button = buttonname
        
        console.log("countClick 1:", currentUser, buttonname)
       
          try {
            await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/setclickscount", {button},{
             withCredentials:true
         })  
         }
         catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }
    }

    /*
    This is the array of universites and theirs colleges. Each college may have several departements.
    Each department is represented as a separate college. For exaple: Gradjevinski fakultet - Gradjevinarstvi, Geodezija, Geoinformatika.
    This way is interface handled unifomly across colleges and departements. For that reason is added 'parentindex'. So, each department has
    parentindex in the array. Look at IsSelected(). This way Gradjevinski fakultet stays highlighted when
    different departements are selected.
    */

    const universities = [
        {
            university: 'University of Belgrade',
            college: [
                 {
                 index: 0,
                 parentindex: 0,
                 collegename: 'Elektrotehnički fakultet',
                 name: 'Elektrotehnički fakultet',
                 departmentname:"",
                 departments: 1,
                 yearsofstudy: 4,
                 displayfreetext: true,
                 freetext:'Lista obaveznih predmeta sa svih smerova',
                    courses:
                    {
                        firstyear:[
                            "Fizika I",
                            "Matematika I",
                            "Matematika II",
                            "Osnovi elektrotehnike I",
                            "Osnovi elektrotehnike II",
                            "Programiranje I",
                            "Programiranje II",

                        ], 
                
                        secondyear: [
                            "Algoritmi i strukture podataka",
                            "Analogna elektronika I",
                            "Arhitektura informaciono-komunikacionih sistema",
                            "Arhitektura računara",

                            "Baze podataka I",

                            "Digitalna elektronika I",
                            "Digitalna elektronika II",

                            "Električna merenja",
                            "Električne mašine",
                            "Elektromagnetika",
                            "Elektroenergetske instalacije niskog napona",
                            "Elektronika",

                            "Fizičko tehnička merenja", 

                            "Kvantna mehanika",

                            "Matematika III",
                            "Mehanika",

                            "Numerička analiza i diskretna matematika",

                            "Objektno orijentisano programiranje I",
                            "Objektno orijentisano programiranje II",

                            "Operativni sistemi I",
                            "Osnovi elektronike",
                            "Osnovi računarske tehnike",
                            "Osnovi telekomunikacija",
                            "Osnovi analogne elektronike",
                            "Osnovi i primena Interneta",

                            "Računarske mreže I", 

                            "Signali i sistemi",
                            "Sistemi automatskog upravljanja",

                            "Teorija električnih kola",
                            "Telekomunikacione mreže",
                            "Telekomunikacije I"
                           
                        ],
                   
                        thirdyear: [
                            "Analiza elektroenergetskih sistema I",
                            "Analogna elektronika II",
                            "Arhitektura i organizacija namenskih računara",

                            "Detekcija i merenje jonizujućeg zračenja", 
                            "Digitalna obrada signala",

                            "Elektroakustika",
                            "Elektromagnetika",
                            "Elementi elektroenergetskih sistema",
                            "Energetski pretvarači I",
                            "Energetski transformatori",
                           
                            "Mrežna administracija i programiranje",
                      
                            "Nuklearna fizika",

                            "Obrada signala I",
                            "Obrtne mašine za naizmeničnu struju",
                            "Operativni sistemi I",
                            
                            "Programiranje internet aplikacija",
                            "Projektovanje VLSI sistema",

                            "Radio komunikacije",
                            "Radiološka i nuklearna medicinska tehnika",
                           
                            "Sistemi automatskog upravljanja I",
                            "Sistemi automatskog upravljanja II",
                            "Sistemski softver",
                            "Stohastički sistemi i estimacija",

                            "Tehnika visokog napona I",
                            "Telekomunikacije II",
                            "Teorija informacija i kodovanja",
                           
                            "Upravljanje u realnom vremenu",
                            "Zaštita podataka"

                        ],
                        fourthyear: [
                            "Dozimetrija i zaštita od zračenja",
                           
                            "Elektromotorni pogoni",

                            "Komutacioni sistemi",
                            "Konkurentno i distribuirano programiranje",

                            "Metode formiranja medicinske slike",
                            "Mikroprocesorski sistemi",
                            "Mrežna bezbednost",

                            "Nuklearna tehnika", 

                            "Optičke i bežične mreže",
                            
                            "Performanse računarskih sistema",
                            "Programski prevodioci I",
                            

                            "Radio sistemi",
                            "Razvodna postrojenja",
                            "Relejna zaštita",

                            "Simulacija nuklearnih procesa",
                            "Sistemi za digitalnu obradu slike",

                            "Tehnike optimizacije u upravljanju sistemima i obradi signala",
                        ]
                    }
                },
                {
                  index: 1,
                  parentindex: 1,
                  collegename:'Gradjevinski fakultet',
                  name: 'Gradjevinski fakultet - Gradjevinarstvo',
                  departmentname:"Gradjevinarstvo",
                  departments: 3,
                  yearsofstudy: 3,
                  displayfreetext: true,
                  freetext:'GRADJEVINARSTVO',
                  courses:
                    {
                        firstyear:[
                            "Geodezija",
                            "Gradjevinski materijali I",
	                        "Matematika I",
                            "Matematika II",
	                        "Nacrtna geometrija sa računarstvom",

                            "Osnove inzenjerske tehnologije",
	                        "Osnove programiranja u Matlab-u",
	                        "Osnove programiranja u Python-u",

                            "Planiranje prostora i saobracaja",

                            "Tehnička fizika",
	                        "Tehnička mehanika I",
                            "Tehnička mehanika II",
	        
                        ],
                        secondyear: [
                            "Ekonomija u gradjevinarstvu",

                            "Gradjevinska fizika",
                            "Gradjevinski materijali II",

                            "Hemija u gradjevinarstvu",
	                        "Hidrotehnika",

                            "Matematika III",
	                        "Mehanika fluida",
                            "Mehanika tla",

                            "Otpornost materijala",

	                        "Pravna regulativa u gradjevinrstvu",
	                        "Putna infrastruktura",

	                        "Statika konstrukcija I",
	                       
	                        "Zgradarstvo",
	                       
                        ],
                        thirdyear: [
                            "Drvene i zidane konstrukcije",

                            "Geoinformacioni sistemi",
                            "Gradjenje puteva i aerodroma",

                            "Hidraulika sistema pod pritiskom II",
                            "Hidrologija",

	                        "Informaciono modeliranje gradjevinskih objekata",

                            "Kvalitet voda",

                            "Osnove geotehničkih konstrukcija",
                            "Osnove inzenjerstva zastite zivotne sredina",
                            "Osnove organizacije i tehnologije gradjenja",
                            "Osnove upravljanja u gradjevinarstvu",

                            "Planiranje i kontrola troškova u gradjevinarstvu",

                            "Računarski podrzano crtanje u gradjevinarstvu",
                            "Računarski podrzano projektovanje saobracajnica",

                            "Statika konstrukcija II",

                            "Teorija betonskih konstrukcija",
                            "Teorija betonskih konstrukcija II",

                            "Celicne konstrukcija I",
                            "Celicne konstrukcije II",

                            "Zeleznička infrostruktura",
                        
                        ]
                    }
                },

                {
                  index: 2,
                  parentindex: 1,
                  collegename:'Gradjevinski fakultet',
                  name: 'Gradjevinski fakultet - Geodezija',
                  departmentname:"Geodezija",
                  yearsofstudy: 3,
                  displayfreetext: true,
                  freetext:'GEODEZIJA',
                    courses:
                    {
                        firstyear:[

                            "Baze podataka",
                            "Kompjuterska vizuelizacija 3D prostora u geodeziji",
                            "Matematika I",
                            "Matematika II",
                            "Osnove ekonomije",
                            "Osnove geologije",
                            "Osnove gradjevinarstva",
                            "Osnove programiranja u Matlab-u",
                            "Osnove programiranja u Python-u",
                            "Osnove stvarnog i upravnog prava",
                            "Računarska geometrija",
                            "Tehnika geodetskih merenja",
                            "Tehnička fizika I",
                            "Tehnička fizika II",
                            "Uvod u geodeziju",
	                      
                        ],
                        secondyear: [

                           "Analiza podataka u MatLab-u",
                            "Analiza podataka u Python-u",
                            "Analiza podataka u R-u",
                            "Digitalna obrada slike",
                            "Elektronika u geodeziji",
                            "Geodetska metrologija",
                            "Geodetski primer 2",
                            "Geodetski primer I",
                            "Geoinformatika",
                            "Matematika III",
                            "Matematička kartografija",
                            "Osnove fotogrametrije i daljinske detekcije",
                            "Prikupljanje podataka o nepokretnostima i vodovima",
                            "Račun izravnanja",
                            "Teorija grešaka geodetskih merenja",

                        ],
                        thirdyear: [

                           "Digitalno modeliranje terena",
                            "Fotogrametrija",
                            "Geodetski planovi",
                            "Geoinformacioni sistemi",
                            "Inzenjerska geodezija I",
                            "Inzenjerska geodezija II",
                            "Katastar",
                            "Opšta i tematska kartografije",
                            "Osnove standardizacije u geodetskoj metrologiji",
                            "Osnove upravljanja nepokretnostima",
                            "Premer globalnim staelitskim navigacionim sistemima",
                            "Satelitska geodezija",
                            "Teorijska geodezija",
                            "Uredjenje zemljišne teritorije",
                            "Uvod u VIM",

                        ]
                    }
                },

                 {
                  index: 3,
                  parentindex: 1,
                  collegename:'Gradjevinski fakultet',
                  name: 'Gradjevinski fakultet - Geoinformatika',
                  departmentname:"Geoinformatika",
                 
                  yearsofstudy: 3,
                  displayfreetext: true,
                  freetext:'GEOINFORMATIKA',
                    courses:
                    {
                        firstyear:[

                            "Disktretne matematičke strukture",
                            "Matematika I",
                            "Matematika II",
                            "Matematička kartografija",
                            "Osnove ekonomije",
                            "Osnove geodezije",
                            "Osnove Programiranja u Python-u",
                            "Osnove stvarnog i upravnog prava",
                            "Osnve računarstva",
                            "Poslovna komunikacija",
                            "Tehnička fizika 1",
                            "Uvod u internet tehnologije",
                            "Vizuelizacija i prezentacija 3D modela u geoinformatici",

                        ],
                        secondyear: [

                            "Analiza podataka u Python-u",
                            "Analiza podataka u R-u",
                            "Baze podataka",
                            "Daljinska detekcija",
                            "Digitalna obrada slike",
                            "Fizički principi daljinske detekcije",
                            "Geoinformatika",
                            "Geostatistika",
                            "Matematika III",
                            "Objektno orijentisano programiranje",
                            "Osnove fotogrametrije i daljinske detekcije",
                            "Satelitska geodezija i navigacija",
                            "Statistička analiza",
                        ],
                        thirdyear: [
                           "Digitalno modeliranje terena",
                            "Funkcionalno programiranje",
                            "Geoinformacioni sistemi",
                            "Informaciono modeliranje gradjeinskih objekata",
                            "Katastarski informacioni sistemi",
                            "Komasacija",
                            "Opšta i tematska kartografija",
                            "Osnove geologije",
                            "Osnove hidrologije",
                            "Osnove ipravljanja nepokretnostima",
                            "Osnove uredjenja prostora",
                            "Prikupljanje podataka o nepokretnostima i vodovima",
                            "Programiranje mobilnih uredjaja",
                            "Razvoj softvera",
                            "Senzori",
                            "VEB programiranje",
                        ]
                    }
                },
               
                {
                index: 4,
                parentindex: 4,
                collegename: 'Mašinski fakultet',
                name: 'Mašinski fakultet',
                departmentname:"",
                departments: 1,
               
                yearsofstudy: 3,
                displayfreetext: false,
                freetext:'',
                courses:
                    {
                        firstyear:[
                            "Algebra i linearna algebra",
                            "Analiza",
                            'Fizika i merenja',
                            'Inženjerski menadžment i ekonomija',
                            'Mašinski materijali I',
                            'Matematika I',
                            'Matematika II',
                            'Mehanika I',
                            "Osnovi mehanike I",
                            "Osnove računarskih sistema",
                            'Otpornost materijala',
                            'Programiranje C jezik',
                            'Računarski alati',
                            "Strukture podataka",

                        ],
                        secondyear: [
                            'Diskretna matematika',
                            'Mašinski elementi I',
                            'Mašinski elementi II',
                            'Mašinski materijali II',
                            "Mašinsko inženjerstvo",
                            'Matematika III',
                            'Mehanika II',
                            'Mehanika III',
                            'Numerička analiza',
                            'Osnove operativnih sistema',
                            'Osnove teorije algoritama',
                            'Osnovi otpornosti konstrukcija',
                            'Termodinamika'
                        ],
                        thirdyear: [
                            'Baze podataka',
                            'Elektrotehnika',
                            'Mehanika fluida',
                            'Numeričke metode',
                            'Objektno orijentisana paradigma',
                            'Osnove automatskog upravljanja',
                            'Osnove mehanike fluida',
                            'Osnove termodinamike i prenošenja toplote',
                            'Tehnologija mašinske obrade'
                        ]
                    }
                },

                {
                 index: 5,
                 parentindex:5,
                 collegename: 'Medicinski fakultet',
                 name: 'Medicinski fakultet',
                 departmentname:"",
                 departments: 1,
                
                 yearsofstudy: 6,
                 displayfreetext: false,
                 freetext:'',
                 courses:
                    {
                        firstyear:[
                            "Anatomija",
                            "Anatomija nervnog sistema kroz kliničke vinjete",
                            "Anatomija pokreta",
                            "Bioneorganska hemija u medicini",
                            "Genetičke osnove humane reprodukcije",
                            "Genetičke osnove čestih bolesti čoveka",
                            "Geni u porodicama i geni u populacijama",
                            "Histologija i embriologija",
                            "Humana genetika",
                            "Medicina i društvo",
                            "Život ćelija od rođenja do smrti",
                        ],
                        secondyear: [
                           "Biohemijske osobenosti pojedinih tkiva",
                           "Genetika prokariota i virusa", 
                           "Medicinska fiziologija",
                           "Medicinska biohemija",
                           "Mikrobiologija",
                           "In vitro modeli u medicinskim istraživanjima",
                           "Imunologija",
                           "Organska jedinjenja u prirodnim lekovitim sirovinama",
                        ],
                        thirdyear: [
                            "Patologija",
                            "Patološka fiziologija",
                            "Klinička propedevtika",
                            "Farmakologija sa toksikologijom",
                            "Epidemiologija",
                            "Medicinska statistika i informatika",
                        ],
                        fourthyear: [
                            "Interna medicina",
                            "Infektivne bolesti",
                            "Neurologija",
                            "Psihijatrija",
                            "Dermatovenerologija",
                            "Radiologija",
                            "Klinička mikrobiologija",
                            "Klinička biohemija"
                        ],
                        fifthyear: [
                            "Hirurgija",
                            "Ginekologija sa akušerstvom",
                            "Nuklearna medicina",
                            "Pedijatrija",
                            "Socijalna medicina",
                        ],
                        sixthyear: [
                            "Oftalmologija",
                            "Otorinolaringologija i maksilofacijalna hirurgija",
                            "Higijena sa medicinom rada",
                            "Sudska medicina",
                            "Klinička farmakologija",
                        ]
                    }
                },
                {
                 index: 6,
                 parentindex: 6,
                 collegename: 'Pravni fakultet',
                 name: 'Pravni fakultet',
                 departmentname:"",
                 departments: 1,
                 yearsofstudy: 4,
                 displayfreetext: false,
                 freetext:'',
                    courses:
                    {
                        firstyear:[
                            "Osnovi sociologije prava",
                            "Rimsko privatno pravo",
                            "Srpska pravna istorija",
                            "Uporedna pravna tradicija",
                            "Ustavno pravo",
                            "Uvod u pravo",
                            "Uvod u pravo evropskih integracija"
                        ],
                        secondyear: [
                            "Gradjansko pravo i Stvarno pravo",
                            "Krivično pravo",
                            "Nasledno pravo",
                            "Osnovi ekonomije",
                            "Porodično pravo",
                            "Kriminologija",
                            "Ekonomsko pravo",
                            "Diplomatsko i konzularno pravo",
                            "Crkveno pravo",
                          
                        ],
                        thirdyear: [
                            "Autonomno pravo",
                            "Kompanijsko pravo",
                            "Kriminalistika",
                            "Krivično procesno pravo",
                            "Ljudska pravo",
                            "Medjunarodno humanitarno pravo",
                            "Medjunarodno javno pravo",
                            "Medjunarodno krivično pravo",
                            "Obligaciono pravo",
                            "Parlamentarno pravo",
                            "Politički sistem",
                            "Posebno upravno pravo",
                            "Pravo intelektualne svojine",
                            "Pravo konkurencije",
                            "Pravo i pravda",
                            "Retorika",
                            "Saobraćajno pravo",
                            "Stečajno pravo",
                            "Upravno pravo",
                            "Upravno-procesno pravo",
                             
                            /*
                            "Kompanijsko pravo",
                            */
                           
                        ],
                        fourthyear : [
                            "Arbitražno pravo",
                            "Bankarsko pravo",
                            "Berzansko pravo",
                            "Ekonomska analiza prava",
                            "Gradjansko procesno pravo",
                            "Kaznena odgovornost pravnih lica i prekršajno pravo",

                            "Medicinsko pravo", 
                            "Medjunarodno privatno pravo",
                            "Medjunarodno radno pravo",
                            "Medjunarodno trgovinsko pravo",
                           
                            "Političke i pravne teorije",
                            "Poresko pravo",
                            "Pravna klinika",
                            "Pravna medicina",
                            "Pravo osiguranja",
                            "Pravosudno organizaciono pravo",

                            "Radno pravo",
                            "Sudska psihologija",
                            "Uvod u filozofiju prava",
                           
                            /*
                            "Trgovinsko pravo",
                            "Medjunarodno izbegličko pravo",
                            "Pravo centralnih banaka",
                            */
                        ],
                    }
                },
               
            ],
        },
        /*
        {
            university: 'University of Vienna',
            college: [
                {
                    name: '',
                    courses:
                        {
                            firstyear:[],
                            secondyear: [],
                            thirdyear: []
                        }
                }
            ]
        },
        {
            university: 'University of Warsaw',
            college: [
                {
                    name: '',
                    courses:
                        {
                            firstyear:[],
                            secondyear: [],
                            thirdyear: []
                        }
                }
            ]
        }
        */
    ]

    const areas = [
       {
        name: "Business and Finance",
        description: 'Accounting, Marketing, Management, ...',
        subareas: [
          {
            name:'Accounting',
            description:''
          },
          {
            name:'Marketing',
            description:''
          },
          {
            name:'Entrepreneurship',
            description:''
          },
          {
            name:'Business Management',
            description:''
          },
        ]
      },
      {
        name: "Computer Science and Technology",
        description: 'Programming, Web development, AI, Data Science, ...',
        subareas: [
          {
            name:'Programming',
            description:''
          },
          {
            name:'Web Development',
            description:''
          },
          {
            name:'Cybersecurity',
            description:''
          },
          {
            name:'Artificial Inteligence',
            description:''
          },
          {
            name:'Data Science',
            description:''
          },
          
        ]
      },
      {
        name: "Engineering",
        description: 'Mechanical, Electrical, Civil, Chemical, ...',
        subareas: [
          {
            name:'Mechanical Engineering',
            description:''
          },
          {
            name:'Electrical Engineering',
            description:''
          },
          {
            name:'Civil Engineering',
            description:''
          },
          {
            name:'Chemical Engineering',
            description:''
          },
          {
            name:'Computer Engineering',
            description:''
          },
          {
            name:'Industrial and Systsems Engineering',
            description:''
          },
          {
            name:'Biomedical/Bioengineering',
            description:''
          },
        {
            name:'Aerospace/Aeronautical',
            description:''
          },
          
        ]
      },
      {
        name: "Foreign Languages",
        description: 'Spanish, French, German, Mandarin Chinese, ...',
        subareas: [
          {
            name:'Spanish',
            description:''
          },
          {
            name:'French',
            description:''
          },
          {
            name:'German',
            description:''
          },
          {
            name:'Mandarin Chinese',
            description:''
          },
          {
            name:'Japanese',
            description:''
          },
          {
            name:'Other',
            description:''
          },
          
        ]
      },
      {
        name: "Health and Medicine",
        description: 'Anatomy, Nutrition, Nursing, ...',
        subareas: [
          {
            name:'Anathomy and Physiology',
            description:''
          },
          {
            name:'Nutrition',
            description:''
          },
          {
            name:'Nursing',
            description:''
          },
          {
            name:'Medical Terminology',
            description:''
          },
      
        ]
      },
      {
        name:"Language Arts",
        description:'Reading, Grammar, Writing, ...',
         subareas: [
          {
            name:'Reading Comprehension',
            description:''
          },
          {
            name:'Grammar',
            description:''
          },
          {
            name:'Creative Writing',
            description:''
          },
          {
            name:'Literary Analysis',
            description:''
          },
          {
            name:'Poetry',
            description:''
          },
          {
            name:'Public Speakng and Debate',
            description:''
          },
      
        ]
      },

      {
        name: "Mathematics",
        description: 'Arithmetic, Algebra, Geometry, Calculus, ...',
         subareas: [
          {
            name:'Arithmetic',
            description:''
          },
          {
            name:'Algebra',
            description:''
          },
          {
            name:'Geometry',
            description:''
          },
          {
            name:'Trigonometry',
            description:''
          },
          {
            name:'Calculus',
            description:''
          },
       
          {
            name:'Statistics and Probability',
            description:''
          },
          {
            name:'Discrete Mathematics',
            description:''
          },
      
        ]
        
      },
      {
        name: "Science",
        description: 'Biology, Physics, Chemistry, Astronomy, ...',
         subareas: [
          {
            name:'Biology',
            description:''
          },
          {
            name:'Chemistry',
            description:''
          },
          {
            name:'Physics',
            description:''
          },
          {
            name:'Earth Science',
            description:''
          },
          {
            name:'Astronomy',
            description:''
          },
          {
            name:'Environmental Science',
            description:''
          },
        ]
      },
    
      {
        name: "Social Studies and Humanities",
        description: 'History, Geography, Economics, Philosophy, ...',
        subareas: [
          {
            name:'History',
            description:''
          },
          {
            name:'Geography',
            description:''
          },
          {
            name:'Civic and Goverment',
            description:''
          },
          {
            name:'Psyhology',
            description:''
          },
          {
            name:'Sociology',
            description:''
          },
          {
            name:'Philosophy',
            description:''
          },
          {
            name:'Anthropology',
            description:''
          },
        ]
      },
      {
        name: "General",
        description: 'Traveling, Recreational, Quiz, Sports, ...',
        subareas: [
        {
            name:'Traveling',
            description:''
        },
          {
            name:'Recreational',
            description:''
        },
          {
            name:'Quiz',
            description:''
        },
        {
            name:'Sports',
            description:''
        },
        {
            name:'Others',
            description:''
        },
        ],
      }
    
      ]

    const getFreeTests = () => {
        /*
        if( boughtschoolyeartests.length > 0 )
            return 0

         if (boughtindividualschooltests.length === 0)
            return 2

        if (boughtindividualschooltests.length === 1)
            return 1
        */
        return 0
    }

    const isSchoolYearTestsBought = () => {
        if (isPromotion())
            return true
        else
        {
   
            for (let i = 0; i < boughtschoolyeartests.length; ++i)
            {
                if (showschoolyearcourses === boughtschoolyeartests[i].schoolyear)
                {
                    if (universities[universityindex].university === boughtschoolyeartests[i].university &&
                        universities[universityindex].college[collegeindex].name === boughtschoolyeartests[i].schoolname
                    )
                    {
                        return true
                    }
                }
            }
        }

       return false
    
    }

    
    const isIndividualSchoolTestBought = (testname) => {
        if (isPromotion())
            return true
        else 
        {

            for (let i = 0; i < boughtindividualschooltests.length; ++i)
            {
                if (showschoolyearcourses === boughtindividualschooltests[i].schoolyear)
                {
                    if (universities[universityindex].university === boughtindividualschooltests[i].university &&
                        universities[universityindex].college[collegeindex].name === boughtindividualschooltests[i].schoolname
                    )
                    {
                        if ( testname === boughtindividualschooltests[i].course)
                            return true
                    }
                }
            }
        }
        
        return false
    
    }

    const isSchoolTestBought = (test) => {
        
        return isSchoolYearTestsBought() || isIndividualSchoolTestBought(test)
    }

    const getTestLanguage = () => {
        const a = localStorage.getItem('Test language')
        if (a === null)
            return 'Serbian'
        else
            return a
    }

    const getUniversityIndex = (university) => {
        
        for ( let i = 0; i < universities.length; ++i)
        {
            if (universities[i].university === university)
                return i
        }
        return 0
    }

   const onSelectCourse = async (course) => {

        let schoolyear = getSchoolYear()
        let language = getTestLanguage()
        console.log("onSelectCourse:", course, schoolyear, language)
        
        setStatus("")
        setPromptsAndResponses([])
        setSubtopics([])

        countClicks("Course")
     
        if (isSchoolTestBought(course))
        {
            setTestIsBought(true)
            setShowQuestionsOnly(false)
        }
        else
        {
            setTestIsBought(false)
            setShowQuestionsOnly(true)
        }

        let alltests;
    
        setIsLoading(true)
        alltests = await getActiveCollegeTests(language, school, schoolyear);
     
        if (alltests.status !== 200 && alltests.status !== 409)
        {
            setStatus("Unable to retrieve tests.")
            setIsLoading(false);
            return;
        }

         if (alltests.status === 409)
        {
            setStatus(changeLanguage('aitest', 'noavailabletests'))
            setChatCollegeTestNames(alltests.tests) //returned empty tests
            setIsLoading(false);
            return;
        }

        if ( alltests.status === 200)
        {
            const filtered = alltests.tests.filter(item => item.chatname.split(' - ')[0] === course);
           
            setChatCollegeTestNames(filtered)
            setSelectedCourse(course)
            
        }
        setIsLoading(false);

    }


    const onLoadBoughtTests= async ()=> {
        console.log("onLoadBoughttests")
      
            if (boughtchatNames.length === 0)
            {
                setIsLoading(true)
                let alltests = await getBoughtTests();
        
                if (alltests.status !== 200 && alltests.status !== 409)
                {
                    setStatus("Unable to retrieve Tests.")
                    setIsLoading(false);
                    return;
                }

                if ( alltests.status === 200)
                {
                    setBoughtChatNames(alltests.tests)
                }
            }
        setIsLoading(false)
        setShowFavouriteTests(!showfavouritetests)
    }

       const onSelectUniversity = async () => {
        console.log("onSelectUniversity")

        setCollegeTestMode(true)
        setSelectTestMode(false)
        setCreateTestMode(false)
        
        setTestPreview(false)
        setPreviewMessage('')

        setChatCollegeTestNames([])
        setSelectedCourse(changeTestLanguage('aitest', 'tests'))

        onClearTest()

        
        if (checkCurrentUser())
        {
            getBoughtSchoolYearTests()
            getBoughtIndividualCollegeTests()
        }
        
    }
   
    const handleDescriptionFocus = () => {
        // Scroll to the target element
        setTimeout(() => {
          if (descriptionRef.current)
            descriptionRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100)
      }

    const onEditTest = (test) => {
        console.log("onEdittest:", test)
        setModifyTest(test)
        setShowModifyTestDialog(true)
    }

    const startBuyTestCheckoutSession = async () => {

        console.log("CreatorID:", buytestcreatorid)
    
        if (buytestcreatorid === 'dsrdjevic@yahoo.com')
        {
            console.log('Proceed with direct payment')
         
            let formattedPrice = buyprice;
            window.open(`/buymytest/${formattedPrice}/${buytestname}/${buytestcreatorid}/${creatorname}/${buytestchatauthorkey}`);
            //window.open(`/checkoutsession/${chat.creator_id}/${price}/${chat.chatname}`, '_blank');
            setShowBuyTestDialog(false)
            
            return false
        }

        try {
        
            let res = await getConnectedAccount(buytestcreatorid)
           

            if (res.status === 404)
            {
                console.log("User not found")
                return
            }

            if (!res.account)
            {
                //console.log("Account is not set.")
                return false
            }

            /*
            if (!res.verified)
            {
                console.log("Account is not verified.")
                return false
            }
            */
          
         
            console.log("RES:", res)
            //let connectedaccount = JSON.parse(res.account)
            let connectedaccount = res

            let url = ''

            let testprice = parseFloat(buyprice)
            // 12% fee
            let fee = (testprice * 0.12).toFixed(2)
            fee = parseFloat(fee)

            console.log("Buyprice, Testprice, fee", buyprice, testprice, fee)

            let inputs= {
                currency: 'usd',
                name: buytestname,
                unit_amount: testprice,
                price: parseFloat(buyprice).toFixed(2),
                
                application_fee_amount:  fee,
                connectedaccountid: connectedaccount.account,
                user_id: currentUser,
                creator_id: buytestcreatorid,
                chatauthorkey: buytestchatauthorkey,
                purchasedate: new Date().toLocaleDateString(),
            }

            console.log("Start Checkout Session:", inputs)
        
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/checkoutsession", {inputs},{
                        withCredentials:true
                    })
                console.log("Response:", res)
                url = res.data.url
            
            } catch(err)
            {
                console.log("Error:", err)
                return false
            
            }

      
            window.open(url,'_blank')
        
        } catch(err)
        {
            console.log("Error:", err)
            return false
        
        }


    return true;

    }


    const onVerifyIdentity = async (connectedaccount) => {
        setIsLoading(true)

        try {
        console.log("Account link START:", connectedaccount.account)
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/account_link", 
                {
                account: connectedaccount.account,
                },
                {
                headers: {
                    "Content-Type": "application/json",
                },
                },
                
                )

            console.log("Account link response:", res)
            if (!res.data.url) {
                // Handle errors on the client side here
                throw new Error("An error occurred: " + res.data.error);
            } else {
                console.log("URL:", res.data.url);
                //window.location.href = res.data.url;
                window.open(res.data.url, '_blank')
            }


        }
        catch (err) {
            console.log("Error:", err)
            throw ("An err occurred: ", err);
        }
        setIsLoading(false)
    }

    
    const handleonClickNavBar = async () => {

        if (createcollegetestmode)
            handleonClickTestCollegeNavBar()
        else
            handleonClicTestNavBar()
    }

     const handleonClickTestCollegeNavBar = async () => {
 
        setStatusNavbar("");
      
       //if (chatNames.length === 0)
       {
          setIsLoading(true);
      
          let tests = await getMyCollegeTests()

          console.log('getMyCollegeTests:', tests)
       
        
          if (tests.status !== 200 && tests.status !== 409)
            {
                setStatusNavbar("Unable to retrieve tests.")
                setIsLoading(false);
                return;
            }
      
          setIsLoading(false);
          if (tests.tests !== null)
            {
              setChatCollegeTestNames(tests.tests)
            }
        }
        setExpanded(!expanded)
     }
 
    const handleonClicTestNavBar = async () => {
 
        setStatusNavbar("");
      
       //if (chatNames.length === 0)
       {
          setIsLoading(true);
      
          let tests = await getMyTests()

          console.log('getMyTests:', tests)
       
        
          if (tests.status !== 200 && tests.status !== 409)
            {
                setStatusNavbar("Unable to retrieve Tests.")
                setIsLoading(false);
                return;
            }
      
          setIsLoading(false);
          if (tests.tests !== null)
            {
              setChatNames(tests.tests)
            }
        }
        setExpanded(!expanded)
     }

    const selectSubtopic = (id) => 
    {
        let updatedSubtopics = [...subtopics]
     
  
    // Use map to return a new array with updated objects
       let a = updatedSubtopics.map((item, index) => {
        // Check if the current index matches the id
        if (index === id) {
            return { ...item, selected: !item.selected }; // Toggle selected for the matched item
        }
        else {
            return { ...item, selected: false };

        }
     
    });

    setSubtopics(a);

    }

    const showSubtopicQuestions = (index) => {
        //console.log("Prompts:", promptsandresponses, index)
        subtopics[index].displayquestions = !subtopics[index].displayquestions
    }
   
    const generateSubtopics = async () => {

        let language = getTestLanguage()
       
        setIsLoading(true)

        console.log("generateSubtopics language:", language)
        let rqst= "Generate up to 10 subtopics from the following context written in " + 
                  `${language}:` + 
                  topic + "." +
                  "End each subtopic with @@@." +
                  "Please, answer in" +  
                  `${language}.` +
                  "Provide an answer in Latin alphabet."

        let req = {
            user: currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
   
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })

            let server_response = JSON.parse(res.data);
            let tokens = server_response.data.split("@@@"); // Split
            let a = []
            for (let i = 0; i < tokens.length; ++i)
                {
                    let newStr = tokens[i].replace(/\n/g, "").trim();

                    if (newStr.length === 0)
                        continue
                
                    let b = {
                        id:i,
                        selected: false,
                        displayquestions: false,
                        subtopic: newStr,
                        promptsandresponses:[]
                    }
                    a.push(b)
                }
            
            setSubtopics([...a])
            setShowSubtopics(true)
            }
            catch (err) {
                console.log("Error:", err)
                setStatus(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false)
            }

        setIsLoading(false)
        
    }

    const getTestKey = (name, author) => {
        return name + "@@@" + author
    }

    const activateTest = async (test) => {
        if (createcollegetestmode)
            activateCollegeTest(test)
        else 
            activateGeneralTest(test)
    }

     const activateGeneralTest = async (test) => {
        console.log('activateGeneralTest')
      
         //activate/deactivate general test
         setIsLoading(true)
         let chatauthorkey = test.chatauthorkey
         let activated = test.activated;
         
         try {
            await axios.post(config.url.API_URL + "/deda_ai_api/tests/updateteststatus", {chatauthorkey, activated},{
             withCredentials:true
         })  
         }
         catch (err) {
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }

        const newArray = [...chatNames];
        newArray[test.id] = test;
        setChatNames(newArray);
        setIsLoading(false)
    }

     const activateCollegeTest = async (test) => {
        console.log('activatecollege test')
     
         //activate/deactivate college test
         setIsLoading(true)
         let chatauthorkey = test.chatauthorkey
         let activated = test.activated;
         
         try {
            await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/updateteststatus", {chatauthorkey, activated},{
             withCredentials:true
         })  
         }
         catch (err) {
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }

        const newArray = [...chatNames];
        newArray[test.id] = test;
        setChatNames(newArray);
        setIsLoading(false)
        
    }
    
    const displayBoughtTest = async (displayedChat) => {
    
        console.log('Displayboughttest')
        setDisplayedChosenChat(displayedChat)
       let questions = JSON.parse(displayedChat.promptsandresponses)
         //fix prompts ids to match array indexes
         let index = 0;
         questions.forEach((item) => {
             item.id = index;
             index++
         })
       
        onClearTest();

        setTestPreview(false)
        setPreviewMessage('')
    
        setPromptsAndResponses([...questions])
      
        setChatName(displayedChat.chatname)
        setDescription(displayedChat.test_description)
    }


    const deleteBoughtTest = async (test) => {
     
        setIsLoading(true);

        let alltests = await getBoughtTests();
       
        if (alltests.status !== 200 && alltests.status !== 409)
        {
            setStatus("Unable to retrieve Tests.")
            setIsLoading(false);
            return;
        }


        if ( alltests.status === 200)
        {
          
            let filteredChats = alltests.tests.filter(chat => chat.id !== test.id)
            let adjustedChats = sortTests(filteredChats)
                  
            var tests = JSON.stringify( adjustedChats )

            //save remaining bought tests 
            try {
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/saveboughttest", {currentUser, tests},{
                    withCredentials:true
                })
            }
            catch (err) {
                setIsLoading(false)
                setStatus(`Error: ${checkServerCode(err.code)}`)
                return;
            }

            setIsLoading(false)
    
            setBoughtChatNames(adjustedChats);
        }
    
         
    }

    const saveBoughtTest = async () => {
        
        let chat = JSON.parse(sessionStorage.getItem('buytest'))
        if (chat === null)
        {
            console.log("invalid Chat")
            return
        }

        console.log("SaveBoughttest:", chat)

        setIsLoading(true)

        try{
         
             let mytests = await getBoughtTests();
            
       
             if (mytests.status !== 200 && mytests.status !== 409)
             {
                 setStatus("Unable to retrieve Tests.")
                 setIsLoading(false);
                 return;
             }
 
             if ( mytests.status === 200)
             {
                 const purchasedate = new Date().toLocaleDateString();
                 let a = {
                     chatauthorkey: chat.chatauthorkey,
                     chatname: chat.chatname,
                     test_id: chat.test_id,
                     creator_name: chat.creator_name,
                     status: 'Active',
                     test_description: chat.test_description,
                     purchasedate: purchasedate,
                     promptsandresponses: chat.promptsandresponses,
                     language: chat.language,
                     area:chat.area,
                     subarea:chat.subarea,
                 }
 
                 mytests.tests.push(a)
                 let sortedtests = sortTests(mytests.tests)
           
                 let tests = JSON.stringify(sortedtests)
                 console.log("SaveBoughtTest")
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/saveboughttest", {currentUser, tests},{
                    withCredentials:true
                })  

                sessionStorage.removeItem('buytest')
                //Update ALLTESTS table:increment count, add last purchase date and add price to TEST earning
                let testkey = chat.chatauthorkey
                let price = parseFloat(chat.price).toFixed(2);
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/updatetestcount", {testkey, purchasedate, price},{
                    withCredentials:true
                })  

                //Update  TESTSACCOUNT table: add price to test balance
                let author= chat.creator_id
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/updateaccountbalance", {author, price},{
                    withCredentials:true
                })  

               
                setSelectTestMode(true)
              
                setBoughtChatNames(sortedtests)
  
            }
         }
         catch (err) {
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
             return;
         }

         setIsLoading(false)

    }

    const onMoveUp = (id, e) => {
      
        var index = promptsandresponses.findIndex((obj => obj.id === id))
        console.log("index: ", index)

        if (index > 0) {
            const newprompts = [...promptsandresponses]

            newprompts.splice(index - 1, 0, newprompts.splice(index, 1).pop());
            //console.log("MOVE UP Before newprompts:", newprompts)

           //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }

                //console.log("MOVE UP Aftere newprompts:", newprompts)
            }
        
            
            setPromptsAndResponses([...newprompts])
        }

    }

    const handleBuyTest_Test = async (chat) => {
        console.log("handleBuyTest_Test")

        setIsLoading(true)

        try{
         
             let mytests = await getBoughtTests();
       
             if (mytests.status !== 200 && mytests.status !== 409)
             {
                 setStatus("Unable to retrieve Tests.")
                 setIsLoading(false);
                 return;
             }
 
             if ( mytests.status === 200)
             {
                 const purchasedate = new Date().toLocaleDateString();
                 let a = {
                     chatauthorkey: chat.chatauthorkey,
                     chatname: chat.chatname,
                     test_id: chat.test_id,
                     creator_name: chat.creator_name,
                     status: 'Active',
                     test_description: chat.test_description,
                     purchasedate: purchasedate,
                     promptsandresponses: chat.promptsandresponses
                 }
 
                 mytests.tests.push(a)
                 let sortedtests = sortTests(mytests.tests)
           
                 let tests = JSON.stringify(sortedtests)
                 console.log("SaveBoughtTest")
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/saveboughttest", {currentUser, tests},{
                    withCredentials:true
                })  

                
                //Update ALLTESTS table:increment count, add last purchase date and add price to TEST earning
                let testkey = chat.chatauthorkey
                let price = parseFloat(chat.price).toFixed(2);
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/updatetestcount", {testkey, purchasedate, price},{
                    withCredentials:true
                })  

                //Update  TESTSACCOUNT table: add price to test balance
                let author= chat.creator_id
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/updateaccountbalance", {author, price},{
                    withCredentials:true
                })  

               
                setSelectTestMode(true)
              
                setBoughtChatNames(sortedtests)
             
            }
         }
         catch (err) {
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
             return;
         }

         setIsLoading(false)

    }

    const onMoveDown = (id, e) => {
      
        var index = promptsandresponses.findIndex((obj => obj.id === id))
        if (index < promptsandresponses.length - 1) {
            const newprompts = [...promptsandresponses]
            newprompts.splice(index + 1, 0, newprompts.splice(index, 1).pop());
            //console.log("MOVE Down Before newprompts:", newprompts)
            //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }
            }
            //console.log("Move down Aftere newprompts:", newprompts)
            setPromptsAndResponses(newprompts)
        }

    }

    const getConnectedAccount = async  (user) => {

        var response = {
            account: '',
            verified: false,
            status:200
        }
   
        try {
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/getconnectedaccount", {user},{
                  withCredentials:true
            })

            let a = JSON.parse(res.data)
      
            response = {
                account: a.account,
                verified: a.verified,
                status: 200
            }
       
        }
        catch(err)
        {
            console.log("Error:", err)
            if (err.response)
            {
                response.status = err.response.status
                console.log("getConnectedAccount Error:", response)
            }
        
        }

      return response
  
      }

    const onCreateTest = async () => {
        console.log("onCreatetest")
      
        if (checkCurrentUser() === false)
            {
                setStatusNavbar(changeLanguage('status', 'pleaselogin'))
                return;
            }
        
   
        if(!createtestmode)
        {
            try {
                let res = await getConnectedAccount(currentUser)
                console.log("GetConnecteAccount:", res)
            
                if (res.status === 200)
                {
                    let account = {
                        account: res.account,
                        verified: res.verified
                    }

                    setConnectedAccount(account)
                    setCreateTestMode(true)
                    setCreateCollegeTestMode(false)
                    setSelectTestMode(false)
                    setShowAccount(false)
                    setShowContext(true)
                   
                }
          
            }
            catch(err) {
                console.log("GetConnecteAccountError:", err)
                return
            }
        }
        else 
        {
            setCreateTestMode(false)
            setSelectTestMode(false)
        }
        setSubtopics([])
        setShowAccount(false)
        setTestPreview(false)
        onClearTest()
        
    }

     const onCreateCollegeTest = async () => {
        console.log("onCreateCollegeTest")
    
        if(!createcollegetestmode)
        {
            try {
                let res = await getConnectedAccount(currentUser)
                //console.log("GetConnectedAccount:", res)
            
                if (res.status === 200)
                {
                    let account = {
                        account: res.account,
                        verified: res.verified
                    }

                    setConnectedAccount(account)
                    setCreateCollegeTestMode(true)
                    setSelectTestMode(false)
                    setShowAccount(false)
                    setShowContext(true)
                   
                }
          
            }
            catch(err) {
                console.log("GetConnecteAccountError:", err)
                return
            }
        }
        else 
        {
            setCreateCollegeTestMode(false)
            setSelectTestMode(false)
        }
        setSubtopics([])
        setShowAccount(false)
        setTestPreview(false)
        onClearTest()
        
    }

    const onClearQuestions = () => {
        setPromptsAndResponses([])
    }

    const saveTestLanguage = (language) => {
        console.log('saveTestLanguage:',language)
        localStorage.setItem('Test language', language)
    }

    const saveCollegeIndex = (index) => {
        localStorage.setItem('College index', index)
    }

    const getCollegeIndex = () => {
        const index = localStorage.getItem('College index')

        if (index === null)
            return '0'
        else
            return index
    }


    const saveTestSchoolYear = (schoolyear) => {
        localStorage.setItem('Test school year', schoolyear)
    }
    const saveTestUniversity = (university) => {
        localStorage.setItem('Test university', university)
    }

    const saveTestCountry = (country) => {
        localStorage.setItem('Test country', country)
    }

     const getSchool = () => {
        /*
        const a = localStorage.getItem('Test school')
        if (a === null)
            return ''
        else
            return a
        */

       const collegeindex = parseInt(getCollegeIndex(), 10);
      
       return universities[universityindex].college[collegeindex].name

    }

    const getSchoolYear = () => {
        const a = localStorage.getItem('Test school year')
        if (a === null)
            return 'First year'
        else
            return a
    }

      const getUniversity = () => {
        const a = localStorage.getItem('Test university')
        if (a === null)
            return 'None'
        else
            return a
    }

        const getCountry = () => {
        const a = localStorage.getItem('Test country')
        if (a === null)
            return 'None'
        else
            return a
    }

    /*
    const onSelectSchool = async (school) => {

        let language = getTestLanguage()
        console.log("onSelectSchool:", language, school, schoolyear)
        saveTestSchool(school)

        if (collegetestmode)
            return;
      
        console.log("onSelectSchool - proceed:")
        
        setStatus("")
        let alltests;
    
        if (collegetestmode)
        {
            setIsLoading(true)
            alltests = await getActiveCollegeTests(language, school, schoolyear);
        }
        else
            return;
        
        if (alltests.status !== 200 && alltests.status !== 409)
        {
            console.log("Error in retrieving tests.")
            setStatus(changeLanguage('aitest', "noavailabletests"))
            setIsLoading(false);
            return;
        }

         if (alltests.status === 409)
        {
            console.log('NoAvailableTests')
            setStatus(changeLanguage('aitest', 'noavailabletests'))
            
            if (selecttestmode)
                setChatNames(alltests.tests) //returned empty tests
            if (collegetestmode)
                 setChatCollegeTestNames(alltests.tests) //returned empty tests
          
            setIsLoading(false);
            return;
        }

        if ( alltests.status === 200)
        {
            if (selecttestmode)
                setChatNames(alltests.tests)
            if (collegetestmode)
                setChatCollegeTestNames(alltests.tests)
        }
        setIsLoading(false);
        
    }
    */

    const getBoughtSchoolYearTests = async () => {

        if (boughtschoolyeartests.length > 0)
            return


        let q = "/deda_ai_api/collegetests/getboughtcollegetests"

        setIsLoading(true)
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0) {
                const row = res.data[0]
                if (row && row.boughtcollegetests) {
                    const boughtTests = row.boughtcollegetests;
                    const testsArray = JSON.parse(boughtTests);
                    setBoughtSchoolYearTests(testsArray)
                }
            }
         
        } 
        catch(err)
        {
            console.log("getBoughtSchoolYearTests Received error:", err)
        }
      
        setIsLoading(false);
      
    }

     const saveBoughtSchoolYearTests = async () => {

         let test = {
            university: universities[universityindex].university,
            schoolname: universities[universityindex].college[collegeindex].name,
            schoolyear: showschoolyearcourses,
        }

        let a = [...boughtschoolyeartests]

        a.push(test)

        var tests = JSON.stringify( a )

        console.log("SaveTests:", tests)

        setIsLoading(true)

        try {
                await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/saveboughtcollegetests", {currentUser, tests},{
                    withCredentials:true
                })

                saveSchoolYearTestPayment(schoolyeartestsprice)
                setBoughtSchoolYearTests(prev => [...prev, test])
        }
        catch (err) {
                setStatus(`Error: ${checkServerCode(err.code)}`)
        }
        
        setIsLoading(false)

    }

    const getBoughtIndividualCollegeTests = async () => {

        //console.log('getBoughtIndividualCollegeTests:', currentUser)

        if (boughtindividualschooltests.length > 0)
            return


        let q = "/deda_ai_api/collegetests/getboughtindividualcollegetests"

        setIsLoading(true)
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0) {
                const row = res.data[0]
                if (row && row.boughtindividualcollegetests) {
                    const boughtTests = row.boughtindividualcollegetests;
                    const testsArray = JSON.parse(boughtTests);
                    setBoughtIndividualSchoolTests(testsArray)
                }
            }
         
        } 
        catch(err)
        {
            console.log("getBoughtIndividualCollegeTests Received error:", err)
        }
      
        setIsLoading(false);
      
    }

     const saveBoughtIndividualCollegeTests = async (course) => {
        
        if (course === "")
        {
            console.log("saveBoughtIndividualCollegeTests: Course empty")
            return
        }

        let test = {
            university: universities[universityindex].university,
            schoolname: universities[universityindex].college[collegeindex].name,
            schoolyear: showschoolyearcourses,
            course: course,
        }

        console.log("saveBoughtIndividualCollegeTests", test)

         setBoughtIndividualSchoolTests(prev => [...prev, test])

        let a = [...boughtindividualschooltests]

        a.push(test)

        var tests = JSON.stringify( a )

        console.log("SaveBoughtIndividualCollegeTests:", tests)

        setIsLoading(true)

        try {
                await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/saveboughtindividualcollegetests", {currentUser, tests},{
                    withCredentials:true
                })

                saveIndividualTestPayment(collegeindividualtestprice)

                setBoughtIndividualSchoolTests(prev => [...prev, test])
        }
        catch (err) {
                setStatus(`Error: ${checkServerCode(err.code)}`)
        }
        
        setIsLoading(false)

    }


    const onChangeSchoolYear = (schoolyear) => {

        saveTestSchoolYear(schoolyear)
        setShowSchoolYearCourses(schoolyear)
        setChatCollegeTestNames([])
        setSelectedCourse(changeTestLanguage('aitest', 'tests'))
        setStatus('')
        setSubtopics([])
     
        if (checkCurrentUser())
        {
            getBoughtSchoolYearTests()
            getBoughtIndividualCollegeTests()
        }
    
        setTestIsBought(true)
        setShowQuestionsOnly(false)
    
    }

     const onChangeLanguage = async (language) => {
       console.log("onChangeLanguage:", language)
        saveTestLanguage(language)
      
        setStatus("")
        let alltests;
        if (selecttestmode)
        {
            setIsLoading(true)
            alltests = await getActiveTests(language);
        }
        else if (collegetestmode)
        {
            setIsLoading(true)
            alltests = await getActiveCollegeTests(testlanguage, school, schoolyear);
        }
        else
            return;
        
        if (alltests.status !== 200 && alltests.status !== 409)
        {
            setStatus("Unable to retrieve tests.")
            setIsLoading(false);
            return;
        }

         if (alltests.status === 409)
        {
            setStatus(changeLanguage('aitest', 'noavailabletests'))
            
            if (selecttestmode)
                setChatNames(alltests.tests) //returned empty tests
            if (collegetestmode)
                 setChatCollegeTestNames(alltests.tests) //returned empty tests
          
            setIsLoading(false);
            return;
        }

        if ( alltests.status === 200)
        {
            if (selecttestmode)
                setChatNames(alltests.tests)
            if (collegetestmode)
                setChatCollegeTestNames(alltests.tests)
        }
        setIsLoading(false);
    }

    const onChooseTest = async () => {
        console.log("onChooseTest")
     
        if (checkCurrentUser() === false)
        {
            return;
        }
    
        if (!selecttestmode)
        {
            setIsLoading(true)
          
            //get all tests
            {
                const testlanguage = getTestLanguage()
                setTestLanguage(testlanguage)
                let alltests = await getActiveTests(testlanguage);
        
                if (alltests.status !== 200 && alltests.status !== 409)
                {
                    setStatus("Unable to retrieve Tests.")
                    setIsLoading(false);
                    return;
                }

                if ( alltests.status === 200)
                {
                    setChatNames(alltests.tests)
                }

            }
              setIsLoading(false);
          
        }
       
        setSelectTestMode(!selecttestmode)
        setCreateTestMode(false)
        
        setTestPreview(false)
        setPreviewMessage('')
        onClearTest()
    }


    const onActivity = async () => {
        console.log("OnActivity")
        let tests = []
        
        if (testactivity.length === 0)
        {
            console.log("OnActivity 1")
            setIsLoading(true)

            tests = await getMyTests()
 
            if (tests.status !== 200 && tests.status !== 409)
            {
                console.log("Unable to retrieve tests.")
                setIsLoading(false);
                return;
            }

            if (tests.tests !== null)
            {
                let a = []
                for ( let i = 0; i < tests.tests.length; ++i)
                {
                    let b = []
                    b.name = tests.tests[i].chatname
                    b.count = tests.tests[i].count
                    b.earning = tests.tests[i].earning
                    b.lastpurchasedate = tests.tests[i].lastpurchasedate
                    a.push(b)
                }
                console.log("A:", a)
                setTestActivity([...a])
                setIsLoading(false)
            }

        }

        setMyCreatedChatNames(tests.tests)
        //setActivity(!activitymode)
       
    }

    const onChange = (id, index, e) => {
      
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        
        let a = [...promptsandresponses]

        for (let i = 0; i < a.length; ++i)
        {
            if (a[i].id === id)
            {
              if (index > -1)
              {
                a[i].response.answer[index][0] = s
              }
              else{
                a[i].prompt = s
                a[i].response.question = s
              }
              setPromptsAndResponses(a) 
              break;
      
            }
            else {
              console.log("DisplayPromptChanged: mismatch", a[i])
            }
        }
     
      
    }

    
      const onMyAccount = async () => {

        if (showaccount)
        {
            setShowAccount(false)
            return
        }
        //get account balance
        setIsLoading(true)
       
        let q = "/deda_ai_api/tests/getaccountbalance"
    
        try{

            const res = await axios.post(config.url.API_URL + q, {currentUser}) 
            
            if (res.data.length > 0) {
                // Row is found
                if (res.data[0].accountbalance) {
                  // Column has a value
                  let balance = res.data[0].accountbalance
                  setAccountBalance(parseFloat(balance).toFixed(2))
                } else {
                  console.log("Row is found but column does not have a value")
                 
                }
            } else {
                console.log("Row is not found")
            }

        } 
        catch(err)
        {
           console.log("Received error:", err)
           setStatus(`Error: ${checkServerCode(err.code)}`)
        }
       
        setIsLoading(false)
       
        setShowAccount(!showaccount)
        console.log("showaccount:", showaccount)
        if (!showaccount)
            onActivity()
    }

    
    const onSaveTest = () => {
        handleonClickNavBar()   
    }

    const onSaveChosenTest_prompt = () => {
      
        handleSaveChosenTestDialog(true)
    }

    const onSaveChosenTest = async () => {
        console.log('onSaveChosenTest')
        setIsLoading(true);
        var a = [...boughtchatNames]
        for (const item of a)
            {
                if (item.chatauthorkey === displayedChosenChat.chatauthorkey)
                {
                    item.promptsandresponses = JSON.stringify(promptsandresponses)
                   break
                }
              
            }

        setBoughtChatNames(a)
        var tests = JSON.stringify( a )

        try {
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/saveboughttest", {currentUser, tests},{
                    withCredentials:true
                })
        }
        catch (err) {
                setStatus(`Error: ${checkServerCode(err.code)}`)
        }

        setIsLoading(false)
    
    }

     const onSaveChosenCollegeTest = async () => {
        console.log("onSaveChosenCollegeTest")
        return
     
        /*
        setIsLoading(true);
        var a = [...boughtchatNames]
        for (const item of a)
            {
                if (item.chatauthorkey === displayedChosenChat.chatauthorkey)
                {
                    item.promptsandresponses = JSON.stringify(promptsandresponses)
                   break
                }
              
            }

        setBoughtChatNames(a)
        var tests = JSON.stringify( a )

        try {
                await axios.post(config.url.API_URL + "/deda_ai_api/tests/saveboughttest", {currentUser, tests},{
                    withCredentials:true
                })
        }
        catch (err) {
                setStatus(`Error: ${checkServerCode(err.code)}`)
        }

        setIsLoading(false)
        */
    }


const onChangeSubtopic = (index, e) => {
        var s = e.target.value;
        console.log('onChangeSubtopic:',index, s)
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        let a = [...subtopics]
        a[index].subtopic = s
        setSubtopics(a)
    }

    const onChangeContext = (e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        setTopic(s)
    }

    const onChangeDescription = (e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        setDescription(s)
    }

    const onResetTest = () => {
        
        let a = [...promptsandresponses]

        a.forEach((item)=> 
        {
            item.response.answer[0][1] = false
            item.response.answer[0][2] = false
            item.response.answer[1][1] = false
            item.response.answer[1][2] = false
            item.response.answer[2][1] = false
            item.response.answer[2][2] = false
        })
       
        setPromptsAndResponses(a)
        setTestScore(0) 
        setReset(false)   
    }

    const onAcceptAnswer = (prompt, answer) => {

     
       /*
        let a = [...promptsandresponses]
        let i = prompt.id
        let score = testScore

        if (prompt.response.answer[0][0] === answer)
        {
            a[i].response.answer[0][2] = true
            if (a[i].response.answer[0][3] === true)
                score += 1
        }
        else if (prompt.response.answer[1][0] === answer)
        {   
            a[i].response.answer[1][2] = true
            if (a[i].response.answer[1][3] === true)
                score += 1
        }           
        else if (prompt.response.answer[2][0] === answer)
        {
            a[i].response.answer[2][2] = true
            if (a[i].response.answer[2][3] === true)
                score += 1
        }

        if (score > testScore)
            updateCredits(25)
        
        setTestScore(score)
        setPromptsAndResponses(a)    
        */

        console.log("onAcceptAnswer")

        let a = [...subtopics]
        let i = prompt.id
        let score = testScore

        if (prompt.response.answer[0][0] === answer)
        {
            a[prompt.subtopicindex].promptsandresponses[i].response.answer[0][2] = true
            if (a[prompt.subtopicindex].promptsandresponses[i].response.answer[0][3] === true)
                score += 1
        }
        else if (prompt.response.answer[1][0] === answer)
        {   
            a[prompt.subtopicindex].promptsandresponses[i].response.answer[1][2] = true
            if (a[prompt.subtopicindex].promptsandresponses[i].response.answer[1][3] === true)
                score += 1
        }           
        else if (prompt.response.answer[2][0] === answer)
        {
            a[prompt.subtopicindex].promptsandresponses[i].response.answer[2][2] = true
            if (a[prompt.subtopicindex].promptsandresponses[i].response.answer[2][3] === true)
                score += 1
        }

        //if (score > testScore)
        //   updateCredits(25)
        
        setTestScore(score)
        setSubtopics(a)    
    }

    const onResetAnswer = (prompt, answer) => {

        console.log("onResetAnswer")
     
        let a = [...subtopics]

        for (let i = 0; i < a[prompt.subtopicindex].promptsandresponses.length; ++i)
        {
           if (a[prompt.subtopicindex].promptsandresponses[i].id === prompt.id)
           {
                if (prompt.response.answer[0][0] === answer)
                {
                    a[prompt.subtopicindex].promptsandresponses[i].response.answer[0][1] = false
                    break;
                }
                else if (prompt.response.answer[1][0] === answer)
                {
                    a[prompt.subtopicindex].promptsandresponses[i].response.answer[1][1] = false
                    break;
                }
                else if (prompt.response.answer[2][0] === answer)
                {
                    a[prompt.subtopicindex].promptsandresponses[i].response.answer[2][1] = false
                    break;
                }
            }
        }
        
        setSubtopics(a)
       
    }

    const onSubmitAnswer = (prompt,answer) => {

        if (prompt.response.answer[0][0] === answer)
        {
            prompt.response.answer[0][1] = true; 
        }
        else if (prompt.response.answer[1][0] === answer)
        {
            prompt.response.answer[1][1] = true;  
        }
         else if (prompt.response.answer[2][0] === answer)
         {
            prompt.response.answer[2][1] = true;
         }

        let a = [...subtopics]

         for (let i = 0; i <  a[prompt.subtopicindex].promptsandresponses.length; ++i)
         {
            if ( a[prompt.subtopicindex].promptsandresponses[i].id === prompt.id)
            {
                 a[prompt.subtopicindex].promptsandresponses[i].response = prompt.response;
                break;
            }
         }
      
         setSubtopics(a)
    }

    const onMoreAnswer = (prompt, question, answer) => {
        setMoreAnswerStatus('')
        setAnswer(answer)
        sendMoreAnswer(question, answer)
    }

    const onMoreQuestion = (prompt, question, answer) => {
        setMoreAnswerStatus('')
        setAnswer(answer)
        sendMoreQuestion(question, answer)
    }

    const sendImproveText = async (prompt, text, index) => {
        let server_response
        let response
       
        let rqst = prompt + text
        //rqst += "Provide the answer in" + language 
        console.log("sendImproveText:", rqst)

        let req = {
            user:currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true)

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          
            server_response = JSON.parse(res.data);
            console.log("sendImproveText:", server_response)

            response = server_response.data

            // Create the updatedModifyTest object with the deep copy
            const updatedModifyTest = {
                ...modifyTest,
                response: {
                ...modifyTest.response,
                answer: {...modifyTest.response.answer }
                }
            }

            if (index === -1)
                updatedModifyTest.prompt = response // Update the question
            else
                updatedModifyTest.response.answer[index][0] = response // Update the answer

            setModifyTest(updatedModifyTest);
          
            updateCredits(server_response.tokens)
      
        } catch (err) {
          
            console.log("onMoreAnswer - Error:", err)
            setMoreAnswerStatus(changeLanguage('aitest', 'somethingwentwrong'))
        }
        setIsLoading(false)
    }

    const sendMoreAnswer = async (question, answer) => {
        console.log("sendMoreAnswer")
        let server_response
        let response
        let text1 = "Tell me more about: " + answer + " related to this question: " + question
        let text2 = "Tell me more about: " + answer + "in general. "
        let text3 = "Apply markdown to result."
        let text4 = "Provide the answer in " + language 
        let rqst = text1 + text2 + text3 + text4

        let req = {
            user:currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true)
       
        setShowMoreAnswerProgressDialog(true)

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })

            server_response = JSON.parse(res.data);

            response = server_response.data
          
            updateCredits(server_response.tokens)
      
        } catch (err) {
          
            console.log("onMoreAnswer - Error:", err)
            setMoreAnswerStatus(changeLanguage('aitest', 'somethingwentwrong'))
            setIsLoading(false)
            setShowMoreAnswerProgressDialog(false)
            return
        }

        setShowMoreAnswerProgressDialog(false)
        setIsLoading(false)
        setStatus("")

        setMoreAnswer(response)
        setShowQuestions(false)
        setShowMoreAnswerDialog(true)
    }

    const sendMoreQuestion = async (question, answer) => {
       
        let server_response
        let response
        let text1 = "Explain why this answer " + answer + " is not correct related to this question: " + question
       
        let text2 = "Apply markdown to result."
        let text3 = "Provide the answer in " + language 
        let rqst = text1 + text2 + text3

        console.log("sendMoreQuestion")

        let req = {
            user:currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true)
       
        setShowMoreAnswerProgressDialog(true)

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            server_response = JSON.parse(res.data);
            console.log("sendMoreQuestion:", server_response)

            response = server_response.data
          
            updateCredits(server_response.tokens)
      
        } catch (err) {
          
            console.log("onMoreQuestion - Error:", err)
            setMoreAnswerStatus(changeLanguage('aitest', 'somethingwentwrong'))
            setIsLoading(false)
            setShowMoreAnswerProgressDialog(false)
            return
        }

    
        setMoreAnswer(response)
        setShowQuestions(false)
        setShowMoreAnswerDialog(true)
    
        setShowMoreAnswerProgressDialog(false)
        setIsLoading(false)
        setStatus("")
    }

    
    const onClearTest = () => {
        setPromptsAndResponses([])
        setChatName('')
        setStatus('')
        setChatPrompt('')
        setTopic('')
        setTestPrice('0.00')
        setCreatorName('')
        setDescription('')
        setTestActive(false)
      
    }

    const handleDeleteTest = (test) => {

        setDialogBoxText(`'${test.chatname}' will be deleted. Do you want to delete it?`)
     
        setOpenDialogBox(true)

    }

     const handleDeleteCollegeTest = (test) => {

        setDialogBoxText(`'${test.chatname}' will be deleted. Do you want to delete it?`)
     
        setOpenDialogBox(true)

    }

     const deleteCollegeTest = async (deletiontest) => {
        console.log("deleteCollegeTest")
       
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        setIsLoading(true)

        let test = JSON.stringify(deletiontest)
     
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/remove", {test}, {
                withCredentials: true
            })

        }
        catch (err) {
            console.log("Delete test err:", err)
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }
        
        let tests = [...chatcollegetestNames]
        let filteredtests = tests.filter(chat => chat.chatauthorkey !== deletiontest.chatauthorkey)
                
        setChatCollegeTestNames([...filteredtests]);
        let key = getTestKey(chatName, creatorname )
        if (key === deletiontest.chatauthorkey) {
            setChatCollegeTestName('')
            setStatus('')
            setChatPrompt('')
            setDescription('')
            setTopic('')
            setSubtopics([])
            setPromptsAndResponses([])
            setTestPrice('0.00')
        }
        setIsLoading(false)
    }


    const deleteTest = async (deletiontest) => {
        console.log("deleteTest")
       
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        setIsLoading(true)

        let test = JSON.stringify(deletiontest)

        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/tests/remove", {test}, {
                withCredentials: true
            })

        }
        catch (err) {
            console.log("Delete test err:", err)
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }
        
        let tests = [...chatNames]
        let filteredtests = tests.filter(chat => chat.chatauthorkey !== deletiontest.chatauthorkey)
                
        setChatNames([...filteredtests]);
        let key = getTestKey(chatName, creatorname )
        if (key === deletiontest.chatauthorkey) {
            setChatName('')
            setStatus('')
            setChatPrompt('')
            setDescription('')
            setTopic('')
            setSubtopics([])
            setPromptsAndResponses([])
            setTestPrice('0.00')
        }
        setIsLoading(false)
    }

    const displayChat = (chat) => {
        console.log('displayChat:', chat)
     
        if (selecttestmode) {
            let price = parseFloat(chat.price).toFixed(0)
           
            if ( price > 0 )
            {
                setTestPreview(true);
                setPreviewMessage(changeLanguage("aitest", 'previewquestions'))
            }
            else
            {
                setTestPreview(false);
            }

        } else {
            setTestPreview(false);
        }
        
        if (createtestmode) {
            setExpanded(!expanded)
            setTestActive(chat.activated);
        } else {
            setTestActive(false);
        }

        let promptsandresponses = JSON.parse(chat.promptsandresponses)
       
        onClearTest();

        //fix prompts ids to match array indexes
        let index = 0;
        promptsandresponses.forEach((item) => {
            item.id = index;
            index++
        })
       
        setPromptsAndResponses(promptsandresponses)
        setChatName(chat.chatname)
       
        setTopic(chat.topic)
        setTestPrice(chat.price)
        setCreatorName(chat.creator_name)
        setArea(chat.area)
        setSubArea(chat.subarea)
        setDescription(chat.test_description)
        setLanguage(chat.language)
        setSubtopics([])
        setSchool(chat.faculty)
        setSchoolYear(chat.schoolyear)

        //This affects dialog boxes displayed by Navbar
        //if (expanded)  setExpanded(!expanded)
        
        setShowAllTests(false)
        handleDescriptionFocus()
    }

    const displayCollegeChat = async (chat) => {
        console.log('displayCollegeChat')

        countClicks("Test")

        let testkey = chat.chatauthorkey
        let q = "/deda_ai_api/collegetests/findtest"
        let test = {};
        setIsLoading(true)
        try{
           const res = await axios.post(config.url.API_URL + q, {testkey}) 
            if (res.data.length > 0 )
            {
                test = res.data[0]
            }
        }
        catch {
            console.log("Error finding a test")
            setIsLoading(false)   
            return   
        }
        setIsLoading(false)        
       
        let temp_subtopics = JSON.parse(test.promptsandresponses)
       
        onClearTest();

        setSubtopics([...temp_subtopics])
        setChatName(test.chatname)
        setTopic(test.topic)
        setTestPrice(test.price)
        setCreatorName(test.creator_name)
        setArea(test.area)
        setSubArea(test.subarea)
        setDescription(test.test_description)
        setLanguage(test.language)
        setSchool(test.faculty)
        setSchoolYear(test.schoolyear)

        //This affects dialog boxes displayed by Navbar
        //if (expanded)  setExpanded(!expanded)
        
        //setShowAllTests(false)
        handleDescriptionFocus()
    }

    const onDeletePrompt = (prompt) => {

        /*
        let a = [...promptsandresponses]
 
        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === prompt.id)
            {
                a[i].response.delete = true;
                break
            }
        }
       
        setPromptsAndResponses(a)
        */

        let a = [...subtopics]
       
        //console.log("OnDelete-1:", a[prompt.subtopicindex], prompt.subtopicindex)

        a[prompt.subtopicindex].promptsandresponses[prompt.id].response.delete = true;

        setSubtopics(a)
       
    }

    const onCancelDelete = (prompt) => {
        /*
        let a = [...promptsandresponses]

        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === prompt.id)
            {
                a[i].response.delete = false;
                break
            }
        }
      
        setPromptsAndResponses(a)
        */

        let a = [...subtopics] 
        a[prompt.subtopicindex].promptsandresponses[prompt.id].response.delete = false;
        setSubtopics(a)
    }

    const onAcceptDelete = (prompt) => {
        /*
        let a = promptsandresponses.filter(item => item.id !== prompt.id)

        for ( let i = 0; i < a.length; ++i)
            a[i].id = i

        setPromptsAndResponses(a)
        */

        //let a = [...subtopics] 
        //a[prompt.subtopicindex].promptsandresponses[prompt.id].response.delete = false;

        let a = [...subtopics]

        let b = a[prompt.subtopicindex].promptsandresponses.filter(item => item.id !== prompt.id)
        for ( let i = 0; i < b.length; ++i)
           b[i].id = i

        console.log('A:', a)
        console.log('B:', b)
        a[prompt.subtopicindex].promptsandresponses = b

        setSubtopics(a)

    }

    const sortTests = (tests) => {
        
        const stringArray=[]
        let sortedArray = []
        let sortedTests = []
        let adjustedTests = []
    
        for (let i = 0; i < tests.length; i++) {
            stringArray.push(tests[i].chatauthorkey); // Push the string into the separate array
        }

        
        sortedArray = [...stringArray].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    
        for (let i = 0; i < sortedArray.length; i++) {
            for (let j = 0; j< tests.length; j++) {
                if (sortedArray[i] === tests[j].chatauthorkey) {
                    sortedTests.push(tests[j])
                }
            }
        }
    
        //adjust indexes
        let i = 0;
        sortedTests.forEach((test) => {
           let newtest = test;
           newtest.id = i;
           adjustedTests.push(newtest);
           i++
        })
       
        //console.log("Adjusted tests:", adjustedTests)
        return adjustedTests;
    
    }

    const getMyTests = async () => {
        console.log("getMyTests:", currentUser)

        let sortedTests  = []
        let alltests = {
            tests: [],
            status: 0
        }

        let q = "/deda_ai_api/tests/getmytests"
    
        try{

            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0) {
                const tests = res.data
                sortedTests = sortTests(tests)    
            }
            else{
                // Handle case when res.data is empty
                console.log("No data in res.data")
            }
        } 
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            if (err.response && err.response.status !== 200)
            {
                console.log("Error1:", err.response.status)
                //alltests.status = err.response.status
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }
        }
       
        alltests = {tests: sortedTests, status: 200}
        return alltests;
    }

    const getMyCollegeTests = async () => {
        console.log("getMyCollegeTests:", testlanguage, school, schoolyear)

        let language = testlanguage
        
        let sortedTests  = []
        let alltests = {
            tests: [],
            status: 0
        }

        let q = "/deda_ai_api/collegetests/getmytests"
    
        try{

            const res = await axios.post(config.url.API_URL + q, {currentUser, language, school, schoolyear}) 

            if (res.data.length > 0) {
                const tests = res.data
                sortedTests = sortTests(tests)    
            }
            else{
                // Handle case when res.data is empty
                console.log("No data in res.data")
            }
        } 
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(err.response.data)
            if (err.response && err.response.status !== 200)
            {
                console.log("Error1:", err.response.status, err.response.data)
                //alltests.status = err.response.status
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }
        }
       
        alltests = {tests: sortedTests, status: 200}
        return alltests;
    }

    
    const getActiveTests = async (language) => {
        console.log("getActiveTests")
        let sortedTests  = []
        let alltests = {
            tests: [],
            status: 0
        }

        let q = "/deda_ai_api/tests/getallactivetests"
    
        try{

            const res = await axios.post(config.url.API_URL + q, {currentUser, language}) 

            if (res.data.length > 0) {
                const tests = res.data
                sortedTests = sortTests(tests)    
            }
            else{
                // Handle case when res.data is empty
                alltests = {tests: [], status: 409}
                return alltests
            }
        } 
        catch(err)
        {
            console.log("getAllTests Received error:", err)
          
            if (err.response && err.response.status !== 409)
            {
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }

            if (err.response && err.response.status === 409)
            {
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }
        }
       
        setIsLoading(true)
        alltests = {tests: sortedTests, status: 200}
        
        return alltests;
    }

     const getActiveCollegeTests = async (language, school, schoolyear) => {
        console.log("getActiveCollegeTests: ", language, school, schoolyear)

        let sortedTests  = []
        let alltests = {
            tests: [],
            status: 0
        }

        let q = "/deda_ai_api/collegetests/getallactivetests"
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser, language, school, schoolyear}) 

            if (res.data.length > 0) {
                const tests = res.data
                //console.log("Received tests:", tests)
                sortedTests = sortTests(tests)    
            }
            else{
                // Handle case when res.data is empty
                alltests = {tests: [], status: 409}
                return alltests
            }
        } 
        catch(err)
        {
            console.log("getCollegeAllTests Received error:", err)
          
            if (err.response && err.response.status !== 409)
            {
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }

            if (err.response && err.response.status === 409)
            {
                alltests = {tests: [], status: err.response.status}
                return alltests;
            }
        }
       
        setIsLoading(true)
        alltests = {tests: sortedTests, status: 200}
        
        return alltests;
    }

    const getBoughtTests = async () => {
        let sortedTests  = []
        let alltests = {
            tests: [],
            status: 0
        }

        let q = "/deda_ai_api/tests/getboughttests"
    
        try{

            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0)
            {
                // Row is found
                if (res.data[0].boughttests) {
                  // Column has a value
                  let mytests = JSON.parse(res.data[0].boughttests)
                 
                  sortedTests = sortTests(mytests)
                  
                } else {
                  console.log("Row is found but column does not have a value")
                }
            } else {
                console.log("Row is not found")
            }
           
        } 
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            if (err.response && err.response.status !== 200)
            {
                alltests.status = err.response.status
                return alltests;
            }
        }
       
        alltests = {tests: sortedTests, status: 200}
        return alltests;
    }

    const onSaveCollegeTest = async () => {
        console.log("onSaveCollegeTest")

         if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (language.length === 0 )
        {
            setStatusNavbar(changeLanguage('aitest', 'nolanguagetosave'))
            return;
        }

        if (school.length === 0 || school === 'Not selected')
        {
            setStatusNavbar(changeLanguage('aitest', 'noschooltosave'))
            return;
        }
        if (creatorname.length === 0 )
        {
            setStatusNavbar(changeLanguage('aitest', 'nocreatornametosave'))
            return;
        }
   
        if (description.length === 0 )
        {
            setStatusNavbar(changeLanguage('aitest', 'nodescriptiontosave'))
            return;
        }

        if (topic.length === 0 )
        {
            setStatusNavbar(changeLanguage('status', 'notopictosave'))
            return;
        }
        if (chatcollegetestName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }


        let testkey = getTestKey(chatcollegetestName, creatorname)
        let newTest = {}

        setIsLoading(true)
        try {
            let qq = "/deda_ai_api/collegetests/getauthor"
            const res = await axios.post(config.url.API_URL + qq, {currentUser, creatorname}) 
            if (res.data.length > 0 )
            {
                if (res.data[0].creator_id !== currentUser)
                {
                    let alerttext = changeLanguage('aitest', 'sameauthor')
                    window.alert(alerttext);
                    setIsLoading(false);
                    return
                }
            }
        }
        catch (err)
        {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }
      
        let q = "/deda_ai_api/collegetests/findtest"
        try{
           const res = await axios.post(config.url.API_URL + q, {testkey}) 
            if (res.data.length > 0 )
            {
               if (res.data[0].creator_id === currentUser)
                {
                    let alerttext = `${changeLanguage('aitest', 'updatetest')} "${chatName}"?`
                   
                    let result = window.confirm(alerttext);
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }
                    else
                    {
                        //Update test
                        newTest.chatauthorkey = testkey
                        newTest.chatname = chatcollegetestName
                        newTest.price = parseFloat(testprice).toFixed(2)
                        newTest.creator_name = creatorname
                        newTest.area = area
                        newTest.subarea = subarea
                        newTest.topic = topic
                        newTest.test_description = description
                        newTest.language = language
                        newTest.faculty = school
                        newTest.schoolyear = schoolyear
                        //reset answers
                         //reset answers
                        let a = [...subtopics]
                        a.forEach((subtopic)=>
                        {
                            subtopic.promptsandresponses.forEach((item)=> 
                                {
                                    item.response.answer[0][1] = false
                                    item.response.answer[0][2] = false
                                    item.response.answer[1][1] = false
                                    item.response.answer[1][2] = false
                                    item.response.answer[2][1] = false
                                    item.response.answer[2][2] = false
                                })
                        })
                        newTest.promptsandresponses = JSON.stringify(a)
                        
                        let test = JSON.stringify(newTest)
                        //console.log("JSONUPDATETEST:", test)
                                
                        try{
                            await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/updatetest", {test},{
                                    withCredentials:true
                        })
                        }
                        catch (err) {
                            console.log("Update err:", err)
                            setIsLoading(false);
                            setStatus(`Error: ${checkServerCode(err.code)}`)
                            return
                        }          
                    }
                }
                else {
                    
                    window.confirm(changeLanguage('aitest', 'sametestname'));
                }

            }
            else if (res.data.length === 0)
                {
                    console.log("Test does not exist.")
                    //Test does not exists so save it
                    newTest = {
                        chatauthorkey: testkey,
                        chatname: chatcollegetestName,
                        test_id: new Date().getTime(),
                        creator_name: creatorname,
                        price: testprice,
                        creator_id: currentUser,
                        topic: topic,
                        count: 0,
                        test_description: description,
                        created: new Date().toLocaleDateString(),
                        language: language,
                        area: area,
                        subarea: subarea,
                        faculty: school,
                        schoolyear: schoolyear,
                     };

                     console.log("New Test:", newTest)
                    //reset answers
                    let a = [...subtopics]
                    a.forEach((subtopic)=>
                    {
                        subtopic.promptsandresponses.forEach((item)=> 
                            {
                                item.response.answer[0][1] = false
                                item.response.answer[0][2] = false
                                item.response.answer[1][1] = false
                                item.response.answer[1][2] = false
                                item.response.answer[2][1] = false
                                item.response.answer[2][2] = false
                            })
                    })
                    newTest.promptsandresponses = JSON.stringify(a)
                 
                    let test = JSON.stringify( newTest)
                        
                    try{
                        await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/save", {test},{
                                withCredentials:true
                            })

                        let tests = [...chatcollegetestNames]
                        tests.push(newTest)

                        let adjustedTests = sortTests(tests)
                        //console.log("onSave:", adjustedTests)
                        setChatCollegeTestNames(adjustedTests)
                            
                    }
                    catch (err) {
                        console.log("Error:", err)
                        setIsLoading(false);
                        setStatus(`Error: ${checkServerCode(err.code)}`)
                        return
                    }
                }
                else {
                        //window.alert("There was a problem while saving the file.");
                        window.alert(changeLanguage('aitest', 'problemsavingfile'));
                }   
            }
        catch (err) {

            setStatus(`Error: ${checkServerCode(err.code)}`)

        }
         
        setIsLoading(false);
        
    }

    const onSave = async () => {

        console.log("onSave")
        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (creatorname.length === 0 )
        {
            setStatusNavbar(changeLanguage('aitest', 'nocreatornametosave'))
            return;
        }
        if (area.length === 0 || subarea.length === 0)
        {
            setStatusNavbar(changeLanguage('aitest', 'noareatosave'))
            return;
        }
        if (description.length === 0 )
        {
            setStatusNavbar(changeLanguage('aitest', 'nodescriptiontosave'))
            return;
        }

        if (topic.length === 0 )
        {
            setStatusNavbar(changeLanguage('status', 'notopictosave'))
            return;
        }
        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }


        let testkey = getTestKey(chatName, creatorname)
        let newTest = {}


        setIsLoading(true)
        try {

            let qq = "/deda_ai_api/tests/getauthor"

            const res = await axios.post(config.url.API_URL + qq, {currentUser, creatorname}) 
        
            if (res.data.length > 0 )
            {
                if (res.data[0].creator_id !== currentUser)
                {
                    let alerttext = changeLanguage('aitest', 'sameauthor')
                    window.alert(alerttext);
                    setIsLoading(false);
                    return
                }
            }
       
        }
        catch (err)
        {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }
      

        let q = "/deda_ai_api/tests/findtest"
        try{
            
           const res = await axios.post(config.url.API_URL + q, {testkey}) 
          
            if (res.data.length > 0 )
            {
               if (res.data[0].creator_id === currentUser)
                {
                    let alerttext = `${changeLanguage('aitest', 'updatetest')} "${chatName}"?`
                   
                    let result = window.confirm(alerttext);
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }
                    else
                    {
                        //Update test
                        newTest.chatauthorkey = testkey
                        newTest.chatname = chatName
                        newTest.price = parseFloat(testprice).toFixed(2)
                        newTest.creator_name = creatorname
                        newTest.area = area
                        newTest.subarea = subarea
                        newTest.topic = topic
                        newTest.test_description = description
                        newTest.language = language
                        //reset answers
                        let a = [...promptsandresponses]
                        a.forEach((item)=> 
                            {
                                item.response.answer[0][1] = false
                                item.response.answer[0][2] = false
                                item.response.answer[1][1] = false
                                item.response.answer[1][2] = false
                                item.response.answer[2][1] = false
                                item.response.answer[2][2] = false
                            })
                        newTest.promptsandresponses = JSON.stringify(a)
                        
                        let test = JSON.stringify(newTest)
                                
                        try{
                            await axios.post(config.url.API_URL + "/deda_ai_api/tests/updatetest", {test},{
                                    withCredentials:true
                        })
                        }
                        catch (err) {
                            console.log("Update err:", err)
                            setIsLoading(false);
                            setStatus(`Error: ${checkServerCode(err.code)}`)
                            return
                        }          
                    }
                }
                else {
                    
                    window.confirm(changeLanguage('aitest', 'sametestname'));
                }

            }
            else if (res.data.length === 0)
                {
                    console.log("Test does not exist.")
                 
                    //Test does not exists so save it
                    newTest = {
                        chatauthorkey: testkey,
                        chatname: chatName,
                        test_id: new Date().getTime(),
                        creator_name: creatorname,
                        price: testprice,
                        creator_id: currentUser,
                        topic: topic,
                        count: 0,
                        test_description: description,
                        created: new Date().toLocaleDateString(),
                        language: language,
                        area: area,
                        subarea: subarea,
                        
                     };

                     console.log("New Test:", newTest)
                    //reset answers
                    let a = [...promptsandresponses]
                    a.forEach((item)=> 
                        {
                            item.response.answer[0][1] = false
                            item.response.answer[0][2] = false
                            item.response.answer[1][1] = false
                            item.response.answer[1][2] = false
                            item.response.answer[2][1] = false
                            item.response.answer[2][2] = false
                        })
                    newTest.promptsandresponses = JSON.stringify(a)
                 
                    let test = JSON.stringify( newTest)
                        
                    try{
                        await axios.post(config.url.API_URL + "/deda_ai_api/tests/save", {test},{
                                withCredentials:true
                            })

                        let tests = [...chatNames]
                        tests.push(newTest)

                        let adjustedTests = sortTests(tests)
                        //console.log("onSave:", adjustedTests)
                        setChatNames(adjustedTests)
                            
                    }
                    catch (err) {
                        console.log("Error:", err)
                        setIsLoading(false);
                        setStatus(`Error: ${checkServerCode(err.code)}`)
                        return
                    }
                }
                else {
                        //window.alert("There was a problem while saving the file.");
                        window.alert(changeLanguage('aitest', 'problemsavingfile'));
                }   
            }
        catch (err) {

            setStatus(`Error: ${checkServerCode(err.code)}`)

        }
         
        setIsLoading(false);
        
    }
    
    
    const onNewQuestions = (subtopicindex) => {
 

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (topic.length === 0 )
        {
            setStatus(changeLanguage('status', 'providetopic'))
            return;
        }

        SendQuestionRequest(subtopicindex)
    }

     const onAutogenerateQuestions = async () => {

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (topic.length === 0 )
        {
            setStatus(changeLanguage('status', 'providetopic'))
            return;
        }

        //send requests one by one
        if (subtopics.length)
        {
            for ( let i = 0; i < subtopics.length; ++i)
            {
                subtopics[i].selected = false
            }

            //let id = 0
            for ( let i = 0; i < subtopics.length; ++i)
            {
                subtopics[i].selected = true
               
                await SendQuestionRequest(i, false)
                
                subtopics[i].selected = false
            }
        }
    }

function parseQuestions(text) {
  if (!text) return [];
  // Strip markdown code fences
  let t = String(text).replace(/```json/gi, "").replace(/```/g, "");
  const start = t.indexOf("[");
  const end = t.lastIndexOf("]");
  if (start === -1 || end === -1) return [];
  try {
    const parsed = JSON.parse(t.slice(start, end + 1));
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.log("JSON parse failed:", err);
    return [];
  }
}
   
    async function SendQuestionRequest(subtopicindex, updatecredit) {

        console.log("SendQuestionRequest")
        let language = getTestLanguage()

        let selectedsubtopicindex = -1

        if (subtopicindex >= 0)
            selectedsubtopicindex = subtopicindex
        else if (subtopics.length)
        {
            for ( let i = 0; i < subtopics.length; ++i)
            {
                if (subtopics[i].selected)
                {
                    selectedsubtopicindex = i
                    break
                }
            }
        }
        
        setStatus("");
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        //include subtopic
       let subtopicstext = ''
       if (selectedsubtopicindex >= 0)
       {
        subtopicstext = "\nSubtopics: " + subtopics[selectedsubtopicindex].subtopic + "\n"
       }

        let topictext = `Topic: ${topic}` + subtopicstext
    

        let rqst = "Instructions:" +
        "Response is a part of a test and should consists of one correct answer and two wrong answers." +
        "All answers should be at a college level. Try to make wrong answers not obviously wrong." +
        "Apply markdown to formulas and expressions and use '$' as a marker instead of '`'." +
        "Make each question unique." +
        "Provide response using Latin alphabet." +
      
         "Provide extended answers to each question in the following JSON format:" +
         "{ 'question': 'question', 'correct': 'correct_answer', 'wrong_1': 'wrong_answer_1', 'wrong_2': 'wrong_answer_2'}" +

        "This is a topic:" + topictext + 
        
        "Task:" +
        "Create 6 test questions and provide one correct answer and two wrong answers for each question about the topic in " +
        `${language}.` + 
        "If Subtopics are given provide questions and answers based on subtopics."
        
      
    
        let s = '';
        if (selectedsubtopicindex >= 0)
        {
            subtopics[selectedsubtopicindex].promptsandresponses.forEach((item, index) => {
                 s += `${index + 1}. ${item.response.question}\n`;
            })
        }
        else {
           promptsandresponses.forEach((item, index) => {
                s += `${index + 1}. ${item.response.question}\n`;
                });
        }


        if (s.length > 0)
        {
            rqst += `Do not repeat the following questions. Each new question must be unique .Make new question conceptually different  from these questions: "${s}"`;
        }
        
        let req = {
            user: currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true);
       
        setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))

        let temp_promptsandresponses = [...promptsandresponses]
        let temp_subtopics = [...subtopics]

        let count = 3

        while (count > 0)
        {
      
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                    withCredentials: true
                })

                let server_response = JSON.parse(res.data);
                console.log("Row data:", server_response)
                // server_response.data is the AI text — pull the JSON array out of it
                const questions = parseQuestions(server_response.data)
                console.log("Response: ", questions)

                let quiz = []
               

                if (questions.length > 0)
                {
                    for (let i = 0; i < questions.length; ++i)
                    {

                       if (questions[i].question !== '' && questions[i].correct !== '' && questions[i].wrong_1 !== '' && questions[i].wrong_2 !== '')
                        {
                        
                            const randomNumber = Math.floor(Math.random() * 3); // generates a random number between 0 and 2 inclusive

                            let a = {}
                            if (randomNumber === 0)
                            {
                                a = {
                                    id: 0,
                                    delete:false,
                                    question: questions[i].question,
                                    answer: [[questions[i].correct, false, false, true], [questions[i].wrong_1, false, false, false], [questions[i].wrong_2, false, false, false]]
                                }

                            }
                            else if (randomNumber === 1)
                            {
                                a = {
                                    id: 0,
                                    delete: false,
                                    question: questions[i].question,
                                    answer: [[questions[i].wrong_1, false, false, false], [questions[i].correct, false, false, true], [questions[i].wrong_2, false, false, false]]
                                }
                            }
                            else if (randomNumber === 2)
                            {
                                a = {
                                    id: 0,
                                    delete: false,
                                    question: questions[i].question,
                                    answer: [[questions[i].wrong_2, false, false, false],  [questions[i].wrong_1, false, false, false], [questions[i].correct, false, false, true],]
                                }
                            }
                            quiz.push(a)
                        }
                    }
                }
                else 
                {
                    setStatus(changeLanguage('quiz', 'somethingwrong'))
                
                    console.log("Something is wrong - Retry")
                    --count
                    continue
                }

                let id = 0
                if (selectedsubtopicindex >= 0)
                {
                    if (temp_subtopics.length && 
                        temp_subtopics[selectedsubtopicindex].promptsandresponses.length) 
                    {
                        let a = temp_subtopics[selectedsubtopicindex].promptsandresponses.length-1
                        id = temp_subtopics[selectedsubtopicindex].promptsandresponses[a].id + 1
                    }
                }
                else {
                    if (temp_promptsandresponses.length) 
                        id = temp_promptsandresponses[temp_promptsandresponses.length - 1].id + 1
                }

                for ( let i = 0; i < quiz.length; i++)
                {
                  
                    
                    if (selectedsubtopicindex >= 0)
                    {
                        let r = {
                            id: id,
                            subtopicindex: selectedsubtopicindex,
                            prompt: quiz[i].question,
                            response: quiz[i],
                        }
                        temp_subtopics[selectedsubtopicindex].promptsandresponses.push(r)
                    }
                    else
                    {
                        let r = {
                            id: id,
                            prompt: quiz[i].question,
                            response: quiz[i],
                        }
                        temp_promptsandresponses.push(r)
                    }
                    id++; 
                }
        
                setStatus("");
                
                if (updatecredit)
                updateCredits(server_response.tokens)
                count = 0
            } catch (err) {
                console.log("Error")
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
                setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
                --count //retry
            }
        }
        
        setPromptsAndResponses([...temp_promptsandresponses])
        setSubtopics([...temp_subtopics])
        setIsLoading(false);
        setWaitOnResponse('')
  
    }

    async function SendAggregateQuestionRequest() {
        
        setStatus("");
    
       let subtopicstext = ''
        if (subtopics.length)
        {
            for ( let i = 0; i < subtopics.length; ++i)
            {
                if (subtopics[i].selected)
                {
                    subtopicstext += subtopics[i].subtopic + "\n"
                    break
                }
            }
        }

        if (subtopicstext)
           subtopicstext = "\nSubtopics: " + subtopicstext

        let topictext = `Topic: ${topic}` + subtopicstext
        
        let rqst = "Instructions:" +
        "Response is a part of a quiz and should consists of one correct answer and two wrong answers." +
        "All answers should be at a college level. Try to make wrong answers not obviously wrong." +
        "Apply markdown to result." +
        "Provide extended answers to each question in the following format:" +
        "@@@Correct:<correct answer>" +
        "@@@Wrong:<wrong answer>" +
        "@@@Wrong:<wrong answer>" +
        
        "This is a topic:" + topictext + 
        
        "Task:" +
        "Create test question and provide one correct answer and two wrong answers about the topic in" +
        `${testlanguage}.` + 
        "If Subtopics are given provide question and answers based on subtopics." +
        "Start each question with @@@Question:." 
     
        let s = '';
        if (promptsandresponses.length <= 5)
        {
            promptsandresponses.forEach((item) => {
                s += item.response.question +'\n';
            })
        }
        else {
            for (let i = promptsandresponses.length -3 ; i < promptsandresponses.length; ++i)
            {
                 s += promptsandresponses[i].response.question + '\n'
            }
        }

        if (s.length > 0)
        {
            //rqst += `Do not create new questions similar to the following questions: "${s}"`;
            //rqst += `Do not create questions similar to these questions: "${s}"`;
            rqst += `Try to make questions semantically different from these already created questions: "${s}"`;
        }

     
        
        let req = {
            user: currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true);
       
        setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
        handleFocus()

        let quiz = []
        let temp_promptsandresponses = [...promptsandresponses]

        for (let j = 1; j <= 3; j++)
        {
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                    withCredentials: true
                })

                let server_response = JSON.parse(res.data);
            
                let tokens = server_response.data.split("@@@"); // Split

                //let quiz = []
                let question =''
                let correct =  ''
                let wrong_1 = ''
                let wrong_2 = ''

                if (tokens.length >= 5)
                {
                    question = tokens[1].replace(/^Question:\s*/, "");
                    correct  = tokens[2].replace(/^Correct:\s*/, "");
                    wrong_1  = tokens[3].replace(/^Wrong:\s*/, "");
                    wrong_2  = tokens[4].replace(/^Wrong:\s*/, "");

                       if (question !== '' && correct !== '' && wrong_1 !== '' && wrong_2 !== '')
                        {
                        
                            const randomNumber = Math.floor(Math.random() * 3); // generates a random number between 0 and 2 inclusive

                            let a = {}
                            if (randomNumber === 0)
                            {
                                a = {
                                    id: 0,
                                    delete:false,
                                    question: question,
                                    answer: [[correct, false, false, true], [wrong_1, false, false, false], [wrong_2, false, false, false]]
                                }

                            }
                            else if (randomNumber === 1)
                            {
                                a = {
                                    id: 0,
                                    delete: false,
                                    question: question,
                                    answer: [[wrong_1, false, false, false], [correct, false, false, true], [wrong_2, false, false, false]]
                                }
                            }
                            else if (randomNumber === 2)
                            {
                                a = {
                                    id: 0,
                                    delete: false,
                                    question: question,
                                    answer: [[wrong_2, false, false, false],  [wrong_1, false, false, false], [correct, false, false, true],]
                                }
                            }
                            quiz.push(a)
                            
                            question = ''
                            correct = ''
                            wrong_1 = ''
                            wrong_2 = ''
                        }
                }
                else 
                {
                    console.log("Invalid tokens length.")
                }
                
                        
                if (quiz.length === 0)
                {   
                    if ( j < 3)
                    {
                        continue;
                    }
                    else {
                        
                        setStatus(changeLanguage('quiz', 'somethingwrong'))
                        setIsLoading(false);
                        console.log("Something is wrong:", j)
                        return quiz;
                     }
                }
                
                let id = 0
                
                if (temp_promptsandresponses.length) 
                    id = temp_promptsandresponses[temp_promptsandresponses.length - 1].id + 1

                for ( let i = 0; i < quiz.length; i++)
                {
                    let r = {
                        id: id,
                        prompt: quiz[i].question,
                        response: quiz[i],
                    }
                    temp_promptsandresponses.push(r)
                    id++; 
                }
                //console.log("temp_promptsandresponses", temp_promptsandresponses)
                setStatus("");
                //updateCredits(server_response.tokens)

            } catch (err) {
                console.log("Error:", j)
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
                setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
                break
            }
        }
        console.log("Questions generted successfully!")

        setIsLoading(false);
        setWaitOnResponse('')
        return quiz
    }

    const getTestScore = () => {
    return testScore
    }


    const getTestCount = () => {

        let count = 0
        for (let i = 0; i < subtopics.length; ++i)
        {
            count += subtopics[i].promptsandresponses.length
        }

       return count
    }

    const saveIndividualTestPayment = async (payment) => {
        
      
        console.log("saveIndividualTestPaymet:", payment)

         let inputs ={
                payment: payment,
                university: universities[universityindex].university,
                college: universities[universityindex].college[collegeindex].name,
                user:currentUser,
             }

         console.log("saveIndividualTestPaymet:", inputs)
       

       
        try{
           
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/saveindividualtestpayment", {inputs},{
                withCredentials:true
            })
            
        
            return res;
        }
        catch (err){
            console.log("Error:", err)
            return err
        }
        
    }

    const saveSchoolYearTestPayment = async (payment) => {
        
      
        console.log("saveSchoolYearTestPaymet:", payment)

         let inputs ={
                payment: payment,
                university: universities[universityindex].university,
                college: universities[universityindex].college[collegeindex].name,
                user:currentUser,
             }

         console.log("saveSchoolYearTestPaymet:", inputs)
       

       
        try{
           
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/saveschoolyeartestpayment", {inputs},{
                withCredentials:true
            })
            
        
            return res;
        }
        catch (err){
            console.log("Error:", err)
            return err
        }
        
    }

    const getUniversityStats = async (university) => {
      try {
        setIsLoading(true);
       
        let inputs ={
                university: university,
        }
        console.log("getCollegeStats:", inputs)

        const res = await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/getuniversitystats", {inputs},{
                withCredentials:true
        })

       
       
        console.log("University data:", res.data)
       setCollegeStats(res.data);
    
    } catch (err) {
        console.error("Error fetching college stats:", err);
        setIsLoading(false);
       
      } finally {
        setIsLoading(false);
      }
    }

    const getCollegeStats = async (university, college) => {
      try {
        setIsLoading(true);
       
        let inputs ={
                university: university,
                college: college,
        }
        console.log("getCollegeStats:", inputs)

        const res = await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/getcollegestats", {inputs},{
                withCredentials:true
        })

        setIndividualTestsPayment(Number(res.data.individualtests) || 0);
        setShoolYearTestsPayment(Number(res.data.schoolyeartests) || 0);
      } catch (err) {
        console.error("Error fetching college stats:", err);
        setIsLoading(false);
       
      } finally {
        setIsLoading(false);
      }
    }

     const getButtonsClicksCount = async () => {
      try {
        setIsLoading(true);

        const res = await axios.post(config.url.API_URL + "/deda_ai_api/collegetests/getclickscount",{
                withCredentials:true
        })

        console.log("ResData:", res.data)
        setIsLoading(false);
        return res.data
      } catch (err) {
        console.error("Error fetching buttons click count:", err);
        setIsLoading(false);
       
      } finally {
        setIsLoading(false);
      }
    }

    return <AITestContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        promptsandresponses,
        setPromptsAndResponses,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        boughtchatNames,
        setBoughtChatNames,
        onClearTest,
        onSave,
        onSaveCollegeTest,
        handleDeleteTest,
        handleDeleteCollegeTest,
        displayChat,
        displayCollegeChat,
        onDeletePrompt,
        onCancelDelete,
        onAcceptDelete,
        topic,
        setTopic,
        onNewQuestions,
        status,
        onSubmitAnswer,
        onAcceptAnswer,
        onResetAnswer,
        onResetTest,
        onChange,
        onChangeContext, 
        onChangeSubtopic,
        reset,
        setReset,
        onCreateTest,
        createtestmode, 
        onChooseTest,
        selecttestmode, 
        onMoveUp, 
        onMoveDown, 
        onMyAccount,
        showaccount,
        onSaveTest,
        onSaveChosenTest,
        onSaveChosenCollegeTest,
        setExpanded,
        expanded,
        testprice,
        
        onActivity,

        creatorname,
        setCreatorName,
        getMyTests,
        //getAllTests,
        setTestPrice,
        onClearQuestions,

        handleBuyTest_Test,
        displayBoughtTest,
        description,
        onChangeDescription,
    
        deleteBoughtTest,
        saveBoughtTest,
        openDialog,
        setOpenDialogBox,
        openConfirmDialog,
        setOpenConfirmDialogBox,
        dialogboxtext,
        deleteTest,
        deleteCollegeTest,
        activateTest,
        accountbalance,
        testpreview,
        testactive,
        setSelectTestMode,
        isLoading,
        setIsLoading,
        subtopics,
        setSubtopics,
        generateSubtopics,
        mycreatedchatNames,
        testactivity,
        setTestActivity, 
        getConnectedAccount,
        handleonClickNavBar,

        onSaveChosenTest_prompt,
        handleSaveChosenTestDialog,
        openSaveChosenTestDialog,

        onVerifyIdentity,
        connectedAccount,
        setConnectedAccount,

        verifyaccount,
        setVerifyAccount,

        buyprice,
        setBuyPrice,

        buytestname,
        setBuyTestName,

        startBuyTestCheckoutSession,
        buytestcreatorid,
        setBuyTestCreatorId,

        buytestchatauthorkey,
        setBuyTestChatAuthorKey,

        onMoreAnswer,
        onMoreQuestion,

        answer,
        moreanswer,
        showmoreanswerdialog,
        moreanswerstatus,
        setMoreAnswerStatus,
        setShowMoreAnswerDialog,
        setMoreAnswer,

        questionsMoreAnswer,
        setQuestionsMoreAnswer,
        
        showModifyTestDialog,
        setShowModifyTestDialog,

        onEditTest,
        modifyTest,
        setModifyTest,

        testScore,

        showContext,
        setShowContext,

        showSubtopics,
        setShowSubtopics, 
        selectSubtopic, 
       
        descriptionRef,
        handleDescriptionFocus,

        previewMessage,
        setPreviewMessage,

        language, 
        setLanguage,
        showTestLanguages,
        setShowTestLanguages,

        showTestBought,
        setShowTestBought,

        showMoreAnswerProgressDialog,
        setShowMoreAnswerProgressDialog,

        area, 
        setArea,
        subarea,
        setSubArea,

        showTestAreaDlg,  
        setShowTestAreaDlg,

        showTestSubareaDlg,  
        setShowTestSubareaDlg,

        areas, 

        areaIndex, 
        setAreaIndex,

        onChangeLanguage,
        getTestLanguage,

        onSelectUniversity,
        collegetestmode,

        showalltests,
        setShowAllTests,

        createcollegetestmode,
        setCreateCollegeTestMode,
        onCreateCollegeTest,

        onLoadBoughtTests,
        showfavouritetests,

        chatcollegetestName, 
        setChatCollegeTestName,
        chatcollegetestNames,
        setChatCollegeTestNames,

        school, 
        setSchool,
        showTestSchool,
        setShowTestSchool,
        //saveTestSchool,
        getSchool, 
        //onSelectSchool,

        schoolyear, 
        setSchoolYear,
   
        saveTestSchoolYear,
        getSchoolYear, 
        onChangeSchoolYear,

        sendImproveText,
        setCollegeTestMode,
        saveTestLanguage,

        getUniversity,
        saveTestUniversity,
        getCountry,
        saveTestCountry,

        showcorrectanswersonly,
        setShowCorrectAnswersOnly,

        showschoolyearcourses,
        setShowSchoolYearCourses,

        universities,
        selectedcourse,
        setSelectedCourse,

        onSelectCourse,
        universityindex, 
        setUniversityIndex,
        getUniversityIndex,
        collegeindex,
        setCollegeIndex,
        getCollegeIndex,

        showTestSchoolYear,
        setShowTestSchoolYear,
        onAutogenerateQuestions,

        setShowQuestionsOnly,
        showquestionsonly,
        showSubtopicQuestions,
        SendAggregateQuestionRequest,

        setDescription,

        setBoughtSchoolYearTests,
        isSchoolYearTestsBought,
        setBoughtIndividualSchoolTests,
        boughtindividualschooltests,
        isSchoolTestBought,

        getBoughtSchoolYearTests,
        saveBoughtSchoolYearTests,
        getBoughtIndividualCollegeTests,
        saveBoughtIndividualCollegeTests,

        getFreeTests,
        testisbought,
        setTestIsBought,
        getTestScore,
        getTestCount,

        boughtcourse,
        setBoughtCourse,

        showquestions,

        collegeindividualtestprice, 
        setCollegeIndividualTestPrice,
        schoolyeartestsprice, 
        setSchoolYearTestsPrice,

        getCollegeStats,
        getUniversityStats,
        individualtestspayment,
        schoolyeartestspayment,

        collegeStats,
        getButtonsClicksCount,

        saveCollegeIndex

    }}>
        {props.children}
    </AITestContext.Provider>
})